const translation = {
IDS_OK:'OK',
IDS_SELECTED_TO_CALC:'Selected to calc',
IDS_CANCEL:'Cancel',
IDS_YES:'Yes',
IDS_NO:'No',
IDS_STOP:'Stop',
IDS_CANCELLING:'Cancelling...',
IDS_CLOSE:'Close',
IDS_BROWSE:'Browse',
IDS_SELECT:'Select',
IDS_CELLPROP:'Cell Properties',
IDS_PRJ_ROOT:'Project',
IDS_PRJ_GRIDS:'Grids',
IDS_PRJ_GRID_GEOMETRY: 'Grid geometry',
IDS_PRJ_STRUCTURE:'Structure',
IDS_PRJ_STATIC_PARAMETERS:'Static Parameters',
IDS_PRJ_DYNAMIC_PARAMETERS:'Dynamic Parameters',
IDS_PRJ_NO_PARAMETERS:'No parameters',
IDS_PRJ_DYNAMIC_PARAMETER_STEPS:'Time Steps',
IDS_PRJ_DYNAMIC_PARAMETER_NO_STEPS:'No Time Steps',
IDS_PRJ_WELLS:'Wells',
IDS_PRJ_WELLGROUPS:'Well Groups',
IDS_PRJ_TWO_WELLGROUPS:'Two groups of wells',
IDS_PRJ_THREE_WELLGROUPS:'Three groups of wells',
IDS_PRJ_HORIZONS: 'Surfaces',//'Horizons',
IDS_PRJ_HORIZON: 'Surface',//'Horizon',
IDS_PRJ_MAPS:'Maps',
IDS_PRJ_FAULTS:'Faults',
IDS_PRJ_STRUCTURAL_MODELS:'Structural Models',
IDS_PRJ_BLOCKED_WELLS:'Blocked Wells',
IDS_PRJ_WELL_PICKS:'Well Picks',
IDS_PRJ_ZONES:'Zones',
IDS_PRJ_ZONE:'Zone',
IDS_FENCES:'Fences',
IDS_REGIONS:'Regions',
IDS_NONE:'None',
IDS_RDS_DATABASE:'Database',
IDS_DATA_SOURCE:'Data source',
IDS_RDS_FIELD_INFORMATION:'Field Information',
IDS_RDS_MODEL:'Data variant',
IDS_FIELD:'Field',
IDS_SHOULD_SELECT_DATABASE:'You should select a database at first',
IDS_MODEL:'Model',
IDS_RESERVOIR:'Reservoir',
IDS_STORAGE_MODELS:'Projects',//'Models',
IDS_PRJSEL_DATABASES:'Databases',
IDS_PRJSEL_FIELDS:'Fields',
IDS_PRJSEL_MODELS:'Models',
IDS_PRJSEL_RESERVOIRS:'Reservoirs',
IDS_PRJSEL_NAME:'Name',
IDS_PRJSEL_DESCRIPTION:'Description',
IDS_PRJSEL_ZONEPROP:'Layer Props',
IDS_PRJSEL_WELLPROD:'Production Data',
IDS_RESERVES_DESC_RES:'Oil reserves',
IDS_RESERVES_DESC_DEN:'Oil reserves density',
IDS_K_PROD:'Productivity',
IDS_ENTIRE_REGION: 'Entire model',
IDS_WELLSRANGE_WOC_REGION: 'Oil-saturated zone',
IDS_HORIZON_TOP_OF: 'Top of',
IDS_HORIZON_ENTIRE_REGION: 'Model top',
IDS_HORIZON_WELLSRANGE_WOC_REGION: 'Oil-water contact',
IDS_GRID_PARAMETERS:'Parameters',
IDS_INIT:'Static',
IDS_REST:'Dynamic',
IDS_TOTAL:'Total',
IDS_ACTIVE:'Active',
IDS_NAME:'Name',
IDS_WELL3D:'Well',
IDS_IMPORT:'Import',
IDS_EXPORT:'Export',
IDS_SECT_RESET:'Clear',
IDS_CALCULATOR: 'Calculator',
IDS_AI_CHAT: 'VEGO AI Chat',
IDS_ARITHM_CMD: 'Expression',
IDS_FC_TITLE:'Cell Filter',
IDS_FC_COORDS:'Coordinates',
IDS_FC_CANCEL:'Cancel',
IDS_FC_APPLY:'Apply',
IDS_FC_RESET:'Reset',
IDS_FC_MORE_GRID_PARAMETERS:'Show more properties',
IDS_FC_HIDE_MORE_GRID_PARAMETERS:'Hide more properties',
IDS_PPD_LIQUIDPROD:'Liquid prod variation',
IDS_PPD_OILPROD:'Oil prod variation',
IDS_PPD_EFFICFUNCTION:'Objective function',
IDS_PPD_WEIGHT_COEFF:'Weighting factor',
IDS_PPD_COORD_DESC:'Coordinate descent',
IDS_PPD_MONTE_CARLO:'Monte-Carlo',
IDS_PPD_TOTAL_INJ:'Total injectivity',
IDS_PPD_OILP_INCR:'Change in oil production',
IDS_PPD_INJ_INCR: 'Change in injectivity',
IDS_PPD_SUMINJ:'injectivity by variant',
IDS_PPD_OL_VAR:'Oil Liquid production variation',
IDS_PPD_VAR_SUMMARY:'Variant summary',
IDS_VAR_DETAILS:'Variant details',
IDS_BASE_VARIANT: 'Base variant',
IDS_OPT_VARIANT:'Variant',
IDS_PPD_OIL_DELTA:'Oil production delta',
IDS_PPD_LIQUID_DELTA:'Liquid production delta',
IDS_PPD_OIL:'Oil',
IDS_PPD_WATER:'Water',
IDS_PPD_PERCWOPT:'WOPT of base',
IDS_PPD_GOALVALUE:'Goal func value',
IDS_STATISTIC_MINVAL:'Min',
IDS_STATISTIC_MAXVAL:'Max',
IDS_STATISTIC_SUM:'Sum',
IDS_STATISTIC_AVERAGE:'Average',
IDS_REGION_STATISTICS:'Region Statistics',
IDS_CENTER:'Center',
IDS_SAVE:'Save',
IDS_OPEN:'Open',
IDS_OPTION3D_BUBBLES:'Bubble map',
IDS_OPTION3D_CELLS:'Grid',
IDS_OPTION3D_GRIDLINE_CELLS:'3D-Cell\'s grid lines',
IDS_OPTION3D_FILL_CELLS:'Fill Cells',
IDS_OPTION3D_HORIZONS:'Horizons',
IDS_OPTION3D_LIGHT:'Light',
IDS_OPTION3D_WELLS:'Wells',
IDS_OPTION3D_GRIDLINES:'Horizon grid lines',
IDS_OPTION3D_HILLSHADING:'Hillshading',
IDS_OPTION3D_LEVELS:'Contours',
IDS_OPTION3D_MAPS:'Maps',
IDS_OPTION3D_MAP_GRIDLINES:'Map grid lines',
IDS_TOTBLOCKNUM:'Number of Cells',
IDS_ACTBLOCKNUM:'Number of Active Cells',
IDS_WELLNUM:'Number of Wells',
IDS_SIZE:'Size',
IDS_CREATE_SON_MODEL:'Create simulation model',
INF_PRJREADING_OPEN:'Opening the project...',
INF_PRJREADING_OPEN_RDS: "Opening the RDS database...",
INF_CALC_OPTIMIZATION_WELLS:  "Createin list of wells for optimization...",

IDS_STOP_PROCESS_QUESTION:'Do you really want to stop process?',
IDS_CALC_MOBRESERVES:'Mobile reserves callculations...',
IDS_MOBRESERVES_DESC_DEN:'Mobile oil reserves density',
IDS_MOBRESERVES_DESC_RES:'Mobile oil reserves',
IDS_REL_AV_PRES_DESC:'Variation of average pressure',
IDS_TYPE:'File type',
IDS_BACK:'Back',
IDS_FINISH:'Finish',
IDS_SKIP:'Skip',
IDS_NEXT_STEP:'Next',
IDS_OPEN_GUIDE:'Open a guide',
IDS_PAGE_TITLE_3DVIEW:'3D View',
IDS_PAGE_TITLE_AVE_PRESSURE:'Pressure Map',
IDS_CALC_FORMATION_PRESSURE:'Calculation of formation pressure',
IDS_CALC_PERMEABILITY:'Calculation of permeability',
IDS_PAGE_TITLE_MOB_RESERVES:'Mobile Reserves Map',
IDS_PAGE_TITLE_TRAJED:'Trajectory Editor',
IDS_PAGE_TITLE_PERF_EDITOR:'Perforation Editor',
IDS_PAGE_TITLE_2DVIEW:'2D View',
IDS_PAGE_TITLE_SECTION:'Section',
IDS_PAGE_BEFOREUNLOAD:'Are you sure you want to navigate away from this application?',
IDS_PAGE_TITLE_WELLPLACE:'Target points',
IDS_PAGE_TITLE_WELLPATTERN:'Well pattern',
IDS_PAGE_TITLE_WELLPRODUCT:'Well Production',
IDS_WATER_CUT:'Water cut',
IDS_TOTAL_PROD:'Total',
IDS_PERF_LENGTH:'Length',
IDS_PERFORATION_LENGTH:'Perforation intervals length',
IDS_PERF_INTERVALS:'Perforation intervals',
IDS_PAGE_WF_OPTIMIZATION:'Water Fluid Optimization',
IDS_PPD_DAY:'Day',
IDS_PPD_WATER_INJ:'Water injection',
IDS_PPD_WATER_PROD:'Water production',
IDS_PPD_OIL_PROD:'Oil production',
IDS_PPD_CREATE_SIM_MODEL:'Create simulation model',
IDS_PPD_WELLS_MODE:'Wells rates',
IDS_PPD_RETURN:'Return',
IDS_WELLSRANGE_INF_NO_SELECTED_VAR:'There are not any selected wells',
IDS_SETTINGS:'Settings',
IDS_OPTIONSTAT_ALLPROPS:'All properties',
IDS_COLOR_LEGEND:'Color legend',
IDS_GEOLOGICAL_MODEL:'Geo\xADlogical model',
IDS_HYDRODYNAMIC_MODEL:'Hydro\xADdynamic model',
IDS_NO_WEBGL:'Your browser does not support WebGL',
IDS_NO_WEBGL20:'Your browser does not support WebGL 2.0',
IDS_RESCAN_MODELS_FOLDER:'Rescan Models folder',
IDS_SCANNING_MODELS_FOLDER:'Scanning Models folder...',
IDS_CREATE_PROJECT:'Create Project',
IDS_DELETE_PROJECT:'Delete Project',
IDS_GEOLOGY: 'Geology',
IDS_GEOLOGICAL_SECTIONS:'Geological Sections',
IDS_DELETE_PROJECT_CONFIRM:'Are you sure to delete the project?',
IDS_CREATE_PROJECT_FOLDER:'Create Folder',
IDS_DELETE_PROJECT_FOLDER:'Delete Folder',
IDS_DELETE_PROJECT_FOLDER_CONFIRM:'Are you sure to delete the folder?',
IDS_PROJECT_NOT_SELECTED: 'No project selected',
IDS_EDIT_PROJECT:'Edit Project',
IDS_OPEN_MODEL:'Open Project',
IDS_BRIEF_MODEL_INFO:'Brief model information',
IDS_REPORT_DOCUMENTS:'Reports',
IDS_ADDITIONAL_FILES:'Supplemental files',
IDS_MODEL_NAME:'Model name',
IDS_MODEL_DESCR:'Description',
IDS_MODEL_TYPE:'Model type',
IDS_MODEL_START_DATE:'Start date',
IDS_MODEL_END_DATE:'End date',
IDS_MODEL_ACTIONS:'Actions',
IDS_CALC_RESULTS:'Calculations result',
INF_WELL3D_TRACE_WELLS:'Performing calculations...',
IDS_CALCULATING_STATISTICS:'Loading statistics...',//'Calculating statistics...',
IDS_ACTION_RUN:'Run',
IDS_ACTION_RESULTS:'Results',
IDS_ACTION_RUN_PROXY:'Run',
IDS_MODEL_PROD_DATA:'Production data view',
IDS_PROD_DATA:'Production data',
IDS_ACTION_RERUN_TEMPEST:'Model output files already exists.<br>Do you really want to recalculate?',
IDS_MODEL_STATISTICS:'Statistics',
IDS_NO_DATA:'No data',
IDS_NO_DATA_BY_TIMESTEP: 'No data',
IDS_VAR_INTEGRAL_PARAMS:'Variant integral parameters',
IDS_CUR_GEOL_RESERVES:'Current geological reserves',
IDS_REMAIN_RESERVES:'Remaining',
IDS_PRODUCTION_RESERVES:'Production',
IDS_INITIAL_RESERVES:'Initial',
IDS_AREA:'Region',
IDS_KT:'ktons',
IDS_MT:'mtons',
IDS_REGIONS_AREAS:'Regions',
IDS_TOOLTIPS:'Tooltips',
IDS_WARNING:'Warning!',
IDS_EMPTY_RESERVES1:'Model does not contain the data to calculate region reserves distribution.',
IDS_EMPTY_RESERVES2:'It\'s possible that \'OIIP\' property was not exported from the model.',
IDS_WELLEVENT_TYPE:'Type',
IDS_WELL_CONTROL:'Control',
IDS_INDEX_PERF:'No',
IDS_DATE_PERF:'Date',
IDS_TYPE_PERF:'Type',
IDS_TOP:'Top',
IDS_BOTTOM:'Bottom',
IDS_FROM_PERF:'From',
IDS_TO_PERF:'To',
IDS_WELL_LIMITS:'Well limits',
IDS_WELL_PRODUCT:'Production',
IDS_WELL_INJECTION:'Injection',
IDS_WELL_STOPPED:'Stopped',
IDS_WELL_PRES:'Bottom hole pressure',
IDS_WELL_LIQUID:'Liquid Production Rate',
IDS_WELL_INJECTRATE:'Injection Rate',
IDS_WELL_BHP:'Borehole Pressure',
IDS_WELLEVENT_EDIT:'Edit',
IDS_SMCUBE:'sm\u00B3', // 'sm3'
IDS_BAR:'bar',
IDS_MD:'mD',
IDS_CP:'cP',
IDS_FACT: 'Fact',
IDS_CALC:'Calc',
IDS_PROBABILITY:'Probability',
IDS_DENS_PROBABILITY:'Probability density',
IDS_WELL_TYPES:'Well types',
IDS_NOTATIONS:'Notations',
IDS_PI_TITLE:'Well Productivity',
IDS_MIN_DIST:'Minimal distance',
IDS_CASING_DIAMETER:'Casing diameter',
IDS_SHOW_ALL_WELLS:'Show all',
IDS_SHOW_FILTERED_WELLS:'Show filtered only',
IDS_PI_PRESSURE:'BHP',
IDS_PI_RESULTED_SKIN:'Skin',
IDS_PI_WELL_RADIUS:'Well radius',
IDS_WELL_EVENTS:'Saturation',
IDS_WELL_PERFORATIONS:'Perforations',
IDS_WELL_WDEBIT:'Water rate',
IDS_WELL_ODEBIT:'Oil rate',
IDS___EVAL:'Evaluation',
IDS___CALC:'Simulation',
IDS_UNCERTAIN_ERR_MESSAGE:'No perforations found for the current time step',
IDS_PI_PERMEABILITY:'Permeability',
IDS_PI_PERMEABILITY_Z:'Vertical permeability',
IDS_PI_PERMEABILITY_X:'Lateral permeability',
IDS_PI_PERMEABILITY_CONF_INVERVAL:'Permeability confidence interval',
IDS_WELLTRACK:'Welltrack',
IDS_SIDETRACK:'Sidetrack',
IDS_PROD_UNITS:'m\u00B3/(day*bar)', // 'm3/(day*bar)'
IDS_PI_RESULTED_PRODUCTIVITY:'Productivity Index',
IDS_PI_UNCERTAINTY:'Uncertainty',
IDS_PERM_STD:'Permeability standard deviation',
IDS_WELL_NAME:'Name',
IDS_PROD_WELL_NAME:'Well name',
IDS_RESERVES:'Geological reserves',
IDS_WELL_PRODUCTIVITY:'Pro\xADduc\xADtiv\xADity ',
IDS_WELL_RESERVES:'Mobile reserves',
IDS_TONS:'tonne',
IDS_METERS:'m',
IDS_PIECE: 'piece',
IDS_CLEAR_TABLE_MESSAGE:'Do you really want to clear table?',
IDS_CLEAR_TRAJ_MESSAGE:'Do you really want to clear well trajectory?',
IDS_CLEAR_PERF_MESSAGE:'Do you really want to clear perforations?',
IDS_RESERVES_AREA:'Area',
IDS_SQUARE_METERS:'m\u00B2', // 'm2'
IDS_KILO:'k',
IDS_CUBE_METERS:'m\u00B3', // 'm3'
IDS_CUBE_METERS_DAY:'m\u00B3/day', // 'm3/day'
IDS_FRACTION:'fraction',
IDS_YEAR:'year',
IDS_BASIC:'Basic',
IDS_MINVAL:'Min.',
IDS_MAXVAL:'Max.',
IDS_NUMVALUES:'Number of values',
IDS_NUMVARIANTS:'Number of variants',
IDS_NUMPIECES:'Number of pieces',
IDS_OPT_VARIANTS:'Variants',
IDS_OPT_NORMALIZED:'Normalized values',
IDS_OPT_CONDITIONS:'Optimization conditions',
IDS_OPT_FIXTOTAL:'Fixed total injection rate',
IDS_OPT_TIMEPERIOD:'Time period',
IDS_OPT_DATESTART:'Start date',
IDS_OPT_DATEND:'Finish date',
IDS_OPT_METHODS:'Optimization methods',
IDS_OPT_SETTING:'Optimization settings',
IDS_OPT_WELLS:'Wells',
IDS_NO_INJWELLS:'There are not injection wells in selected region\n\ror injectivity is zero on last time step of the model.',
IDS_PROB_DENS:'Probability density',
IDS_PROB_DIST:'Cummulative distribution',
IDS_SHOW_MORE:'Show more',
IDS_SHOW_LESS:'Hide',
IDS_SHOW_SECTION:'Show section',
IDS_CLEAR_SECTION:'Clear section',
IDS_REGION_RESERVES:'Region reserves',
IDS_HIST_LABEL_CELLS:'Cells',
IDS_MULTIVARIANT_CALCULATION:'Uncertainty calculation',
IDS_STRUCTURAL_MODELING:'Structural Modeling',
IDS_FAULT_MODELING:'Fault Modeling',
IDS_HORIZON_MODELING:'Horizon Modeling',
IDS_GRID_MODELING:'Grid Modeling',
IDS_BW_MODELING:'Blocked Wells',
IDS_FACIES_INDICATOR_MODELING:'Facies Modelling',
IDS_RUN_JOB:'Run',
IDS_RUN_WORKFLOW:'Run',
IDS_CREATE_FAULT_MODEL:'Create Fault Model',
IDS_CREATE_HORIZON_MODEL:'Create Horizon Model',
IDS_CREATE_GRID:'Create Grid',
IDS_CREATE_BW:'Create Blocked Wells',
IDS_CREATE_FACIES_INDICATOR_MODEL:'Create Facies Indicator',
IDS_SAVE_THE_PROJECT:'Save Project',
IDS_MODEL_PUBLISH:'Publish Model',
IDS_MODEL_PASSPORT:'Model Passport',
IDS_MODEL_GPD:'Geophysical Description',
IDS_MODEL_ECONOMIC_PASSPORT:'Economic Model Passport',
IDS_CHOOSE_MODEL_FOR_START:'To start the work select a project in the left tree',
IDS_CHOOSE_OR_CREATE_MODEL_FOR_START:'To start the work create or select a project in the left tree',
IDS_CALC_PERFS_BUTTON:'Calculate',
IDS_APPLY_SUGGESTED_PERFS_BUTTON:'Apply',
IDS_CALC_PERFS_HEADER:'Perforation filters',
IDS_WISH_SAVE_CHANGES:'All changes will be lost. Do you wish to save changes?',
IDS_PRJ_CREATE_SUCCESS:'The project is successfully saved',
IDS_HIGHLIGHT_SELECTED_WELLS:'Highlighted selected wells',
IDS_KRUBLES:'Currency',
IDS_ADD_WELL:'Add New Well',
IDS_IMPORT_WELLS_FROM_MODEL:'Import Wells From Model...',
IDS_IMPORT_WELLS_FROM_FILE:'Import Wells From File...',
IDS_IMPORT_WELLS_FROM_RDS:'Import Wells From Database...',
IDS_IMPORT_TRAJECTORY_FROM_STORAGE:'Import Trajectory From Model...',
IDS_IMPORT_TRAJECTORY_FROM_FILE:'Import Trajectory From File...',
IDS_DEL_WELL:'Delete',
IDS_RENAME_WELL:'Rename',
IDS_RENAME_REGION:'Rename',
IDS_PERF_SHORT:'P',
IDS_ISOL_SHORT:'I',
IDS_ADD_WELL_BRANCH:'Add sidetrack',
IDS_RUN_PLUGIN: 'Run plugin...',
IDS_BUILD_LEVELS: 'Build levels...',
IDS_LOAD_SECT_DATA: 'Loading section data...',
IDS_LOAD_DIAG_DATA: 'Loading diagram data...',
IDS_LOAD_2D_GRID_DATA: 'Loading map data...',
IDS_LOAD_3D_GRID_DATA: 'Loading 3D grid data...',
IDS_LOAD_CELL_DATA: 'Loading cell data...',
IDS_LOAD_PRODUCTION_DATA: 'Loading Production data...',
IDS_LOAD_FROM_DB:'Load data',
IDS_START_WELL_BRANCH:'Kick off sidetrack',
IDS_CALC_WELL_BRANCH:'Compute sidetrack',
IDS_CALC_WELL_BRANCH_CHART:'Productivity Distribution',
IDS_SAVE_RESULTS:'Submit',
IDS_RUN_BRANCH_OPTIMIZATION:'Run Distribution',
IDS_CALC_PRODUCTIVITY:'Run',
IDS_STOPPED_OR_INJECTOR_WELL: "stopped or injector well",
IDS_DEL_PERF:'Delete',
IDS_OMD_FILE_ACTIONS:'Actions',
IDS_OMD_DOCUMENT_CALCULATE:'Calculate',
IDS_OMD_DOCUMENT_RECALCULATE:'Recalculate',
IDS_OMD_DOCUMENT_STOP:'Stop',
IDS_OMD_FILE_ACCEPT:'Accept',
IDS_OMD_FILE_REJECT:'Reject',
IDS_OMD_FILE_ADD_DESCRIPTION:'Add description',
IDS_EDIT_SHORTPROD:'Production forecast',
IDS_EDIT_MIDDLEPROD:'Middle term production forecast',
IDS_EDIT_FLOWMODEL:'Create flow model',
IDS_FLOW_MODEL: 'Flow model',
IDS_PATH_TO_MODEL: 'Path to the model',
IDS_OPT_INJECTIVITY:'Injectivity',
IDS_OPT_BHP:'Bottom hole pressure',
IDS_OPT_BHP_INJ:'Bottom hole pressure. Injector',
IDS_OPT_BHP_PROD:'Bottom hole pressure. Producer',
IDS_OPT_PARAMETERS:'Control parameters',

IDS_WELL_DIAG:'Well diagram',
IDS_WELLS_DIAG:'Wells diagram',
IDS_WELLS_DIAG_READOUT: 'Readout',
IDS_WELL_DIAG_FLATTING: 'Flattening horizon levels',
IDS_WELL_DIAG_UNFLATTING: 'Remove flattening', //'Unflatten'
IDS_WELLDIAG_VIEWER:'Open well data viewer',
IDS_PRODCARD_VIEWER:'Open well prod card table',
IDS_WELL_SHOW_SECTION:'Show section',
IDS_WELL_ADD_TO_SECTION:'Add to section',
IDS_WELL_DEL_FROM_SECTION:'Delete from section',
IDS_WELL_ADD_TO_DIAGRAM: 'Add to diagram',
IDS_WELL_DEL_FROM_DIAGRAM: 'Delete from diagram',
IDS_TYPE_NEW_WELL:'New well\'s type',
IDS_HORIZONTAL_WELL:'Horizontal well',
IDS_VERTICAL_WELL:'Vertical well',
IDS_AZIMUTH_NEW_WELL: 'Azimuth',
IDS_ROTATION_NUM_NEW_WELL: 'Rotations number',
IDS_LENGTH_NEW_WELL:'Length',
IDS_INCLINATION_NEW_WELL:'Inclination',
IDS_SIDETRACK_PROD_DISTRIBUTION_CALC:'Sidetrack productivity calculation',
IDS_PRODUCTIVITY_COMPUTATION:'Well production forecast',
IDS_BRANCH_STICKING_OUT_ACTION:'Sticking Out Action',
IDS_BRANCH_STICKING_OUT_NO:'No Action',
IDS_BRANCH_STICKING_OUT_TRUNCATE:'Truncate',
IDS_BRANCH_STICKING_OUT_BEND:'Bend',
IDS_CALC_WELL_BRANCH_GEOMETRY:'Trajectory',
IDS_CALC_WELL_BY_TEMPLATE:'Template',
IDS_SWEET_SPOT_STEP: 'Step',
IDS_SWEET_SPOT_NUM_VARIANTS: 'Max number of variants',
IDS_PRESSURE_CHARACTERISTICS:'Formation pressure',
IDS_LIQUID:'Liquid',
IDS_SOIL:'Oil saturation',
IDS_IMPORT_FROM_RMS:'Import from RMS project',
IDS_IMPORT_FROM_PROJECT: 'from project',
IDS_IMPORT_FROM_FILE:'Import from file',
IDS_CALC_WELL_BRANCH_ADDITION:'Additional',
IDS_CALC_WELL_BRANCH_SAVE:'Save',
IDS_CALC_WELL_BRANCH_CANCEL:'Cancel',
IDS_CALC_WELL_BRANCH_CREATE:'Create',
IDS_START_WELL_POINT:'In the Map view specify the starting trajectory point',
IDS_START_WELL_BRANCH_POINT:'In the Section view specify the starting sidetrakc point',
IDS_MOVE_WELL_POINT:'In the Map view move the starting trajectory point if necessary',
IDS_MOVE_WELL_BRANCH_POINT:'In the Section move the starting sidetrack point along parent well trajectory if necessary',
IDS_CREATE_TRAJ_METHOD:'Creation Method',
IDS_CREATE_TRAJ_MANUALLY:'Manually',
IDS_CREATE_TRAJ_BY_PARAMS:'By Paremeters',
IDS_TRUNCATE_TRAJ:'Truncate trajectory on a section',
IDS_SHOW_LABEL_TVD:'Show TVD labels',
IDS_SHOW_LABEL_MD:'Show MD labels',
IDS_APPLICATION_SETTINGS:'Settings',
IDS_SHOW_MORE_SETTINGS:'Show more',
IDS_SMART_SETTINGS:'Simulation settings',
IDS_SMART_SIMULATOR:'Simulator',
IDS_GENERAL_INFO:'General information',
IDS_RESERVES_PER_WELL:'Reserves per well',
IDS_WELLBORE_LENGTH:'Sidetrack length',
IDS_DIST_SS_TO_WELL: 'Distance to sweet spot',
IDS_DIST_SS_TO_WELL_FULL: 'Distance to sweet spot',
IDS_WELL_PRODUCTION:'Well production',
IDS_CREATE_SIMUL_MESS:'Do you really want to create simulation model?',
IDS_DELTA_OIL_RATE:'Incr. oil production',
IDS_RESERVOIR_PRES_CHANGE:'Change in reservoir pressure',
IDS_GLPT:'Liquid production total',
IDS_WBHP:'Bottom hole pressure',
IDS_WBHPH:'History of bottom hole pressure',
IDS_WGIR:'Gas injection rate',
IDS_WGIRH:'History of gas injection rate',
IDS_WGIT:'Total gas volume injected',
IDS_WGITH:'History of total gas volume was injected',
IDS_WLPR:'Liquid production rate',
IDS_WLPRH:'Liquid production rate history',
IDS_WOPR:'Oil production rate',
IDS_WOPRH:'Oil production rate history',
IDS_WWPR:'Water production rate',
IDS_WWPRH:'Water production rate history',
IDS_WOPT:'Oil production total',
IDS_WOPT_CHANGE:'Change in oil production total',
IDS_WOPTH:'Oil production total history',
IDS_WWPT:'Water production total',
IDS_WWPTH:'Water production total history',
IDS_WGPR:'Gas production rate',
IDS_WGPRH:'Gas production rate history',
IDS_WGPT:'Gas production total',
IDS_WGPTH:'Gas production total history',
IDS_WWCT:'Water cut',
IDS_WWCTH:'Water cut history',
IDS_WWIT:'Water injection total',
IDS_WWIT_CHANGE:'Change in Water injection total',
IDS_WWITH:'Water injection total history',
IDS_WWIR:'Water injection rate',
IDS_WWIRH:'Water injection rate history',
IDS_WLPT_CHANGE:'Change in liquid production total',
IDS_WLPT:'Liquid production total',
IDS_WLPTH:'Liquid production total history',
IDS_WOPT_PLOT:'Oil production',
IDS_WOPR_PLOT:'Oil rate',
IDS_WLPT_PLOT:'Liquid production',
IDS_WLPR_PLOT:'Liquid rate',
IDS_WWIR_PLOT:'Water injection rate',
IDS_PERF_EDIT_MODE:'Edit mode',
IDS_PERF_VIEW_MODE:'View mode',
IDS_PRESS_DIFF_LESS:'Bottomhole pressure should be less than reservoir',
IDS_MONTH_JAN:'Jan',
IDS_MONTH_FEB:'Feb',
IDS_MONTH_MAR:'Mar',
IDS_MONTH_APR:'Apr',
IDS_MONTH_MAY:'May',
IDS_MONTH_JUN:'Jun',
IDS_MONTH_JUL:'Jul',
IDS_MONTH_AUG:'Aug',
IDS_MONTH_SEP:'Sep',
IDS_MONTH_OCT:'Oct',
IDS_MONTH_NOV:'Nov',
IDS_MONTH_DEC:'Dec',
IDS_DAY_MON:'Mon',
IDS_DAY_TUE:'Tue',
IDS_DAY_WED:'Wed',
IDS_DAY_THU:'Thu',
IDS_DAY_FRI:'Fri',
IDS_DAY_SAT:'Sat',
IDS_DAY_SUN:'Sun',
IDS_CREATE_GRID_BTN:'Meshing',
IDS_INTERFERENCE:'Interference',
IDS_WELL_INFO:'Well info',
IDS_WELL_3D_FENCE:'Well3d fence',
IDS_DURATION_CALC:'Forecast interval',
IDS_DELTA_PROPS_PPD:'Change in indicators relative to the base case',
IDS_PPD_MIN_GREATER_MAX: 'Min. > Max.',
IDS_PPD_MAX_LESS_MIN: 'Max. < Min.',
IDS_PPD_OUT_OF_INTERVAL: 'A base value out of interval [Min. , Max.]',
IDS_EFFECTIVE_INJECTIVITY: 'Effective injectivity',
IDS_COEFFICIENT: 'Connection coefficient',
IDS_PROD_INCREASE : 'Change in oil Production',
IDS_PPD_LIQUID_INJECTION_INCR: 'Change in liquid injection',
IDS_LIQUID_INCREASE: 'Change in liquid production',
IDS_PRESSURE_LIMIT: 'Pressure boundary',
IDS_DIAMETER_FILTER_CONDITION_FAILED: 'Diameter filter condition failed.',
IDS_DISTANCE_FILTER_CONDITION_FAILED: 'Distance filter condition failed.',
IDS_ODEBIT_FILTER_CONDITION_FAILED: 'Oil debit filter condition failed.',
IDS_WATERCUT_FILTER_CONDITION_FAILED: 'Watercut filter condition failed.',
IDS_BRANCH_LENGTH_FILTER_CONDITION_FAILED: 'Branch length filter condition failed.',
IDS_ECLIPSE_SHUT_WELL:'Shut well',
IDS_ECLIPSE_PROD_WELL:'Oil Producer',
IDS_ECLIPSE_OINJ_WELL:'Oil Injector',
IDS_ECLIPSE_WINJ_WELL:'Water injector',
IDS_ECLIPSE_GINJ_WELL:'Gas injector',
IDS_VEGO_GAS_WELL:'Gas producer',
IDS_VEGO_PROD_WELL:'Producer',
IDS_UNKNOWN_WELL:'Unknown well',
IDS_PROD_STOPPED_WELL:'Producer stopped',
IDS_INJ_STOPPED_WELL:'Injector stopped',
IDS_STREAM_WELL_PROD:'Producer',
IDS_STREAM_WELL_INJ:'Injector',
IDS_APPLY:'Apply',
IDS_OPTIONMODEL_COORSYSTEM:'Coordinate system',
IDS_OPTIONMODEL_LEFTCOOR:'Left',
IDS_OPTIONMODEL_RIGHTCOOR:'Right',
IDS_ADD_WELL_TO_SECTION:'No wells added to the section. To add the well, press \uFE19 icon near it\'s name in the tree on the left and choose \'Add to section\'',
IDS_ADD_WELL_TO_DIAGRAM: 'No wells added to the diagram. To add the well, press \uFE19 icon near it\'s name in the tree on the left and choose \'Add to diagram\'',
IDS_CHOOSE_ANY_WELL:'Select well in the tree on the left or create it',
IDS_CHOOSE_ANY_WELL_TO_CREATE_BRANCH:'To create a sidetrack, choose well in the tree on the left',
IDS_CHOOSE_SWEETSPOT_TO_CREATE_BRANCH: 'To create a sidetrack, choose sweetspot',
IDS_CHOOSE_ANY_WELL_FOR_DIAGRAM:'Select well in the tree on the left',
IDS_NEED_SAVE_FOR_CALC:'Unable to calculate, because the well is not saved yet. Do you want to save the well?',
IDS_WELL_TRAJ_EMPTY:'Well xyz-trajectory is empty',
IDS_CANNOT_BUILD_SECTION_BY_WELL:'Cannot build a section along well',
IDS_WELL_TRAJ_ONLY_POINT:'well xyz-trajectory contains one point only. Add some points to the trajectory using a series of double clicks on the map view',
IDS_SET_TRAJ_USING_DOUBLE_CLICKS:'Set the trajectory using a series of double clicks on the map view',
IDS_PALETTE_COLOR_TABLE_SETTINGS:'Palette Settings',
IDS_PALETTE_VALUE:'Value',
IDS_PALETTE_COLOR:'Color',
IDS_PALETTE_SMOOTH:'Smooth',
IDS_PALETTE_GRADUATED:'Discrete',
IDS_PALETTE_DISCRETE:'Discrete',
IDS_PALETTE_MIN:'Min',
IDS_PALETTE_MAX:'Max',
IDS_PALETTE_MINMAX_SOURCE:'Take min/max from',
IDS_PALETTE_MINMAX_CUSTOM:'Custom',
IDS_PALETTE_MINMAX_ALL_CELLS:'All cells',
IDS_PALETTE_MINMAX_VIS_CELLS:'Visible cells',
IDS_PALETTE_MINMAX_ALL_TIME:'All time steps',
IDS_PALETTE_MINMAX_CUR_TIME:'Current time step',
IDS_PALETTE_RANGE:'Limit values',
IDS_PALETTE_MINMAX_AUTO:'Auto',
IDS_PALETTE_SPECIAL_COLORS:'Use special colors for values below min and above max',
IDS_PALETTE_COLORS:'Colors',
IDS_PALETTE_ADD_COLOR:'Add color',
IDS_PALETTE_REMOVE_COLOR:'Remove color',
IDS_PALETTE_FLIP:'Flip colors',
IDS_PALETTE_SET_REGULAR:'Set regular ticks',
IDS_PALETTE_APPEND_COLOR:'Append',
IDS_PALETTE_DELETE_COLOR: 'Delete',
IDS_PALETTE_CHANGE_VALUE: 'Change value',
IDS_PALETTE_CHANGE_COLOR: 'Change color',
IDS_PALETTE_INVERTED: 'Invert',
IDS_PALETTE_SELECT_GAMMA:'Color table',
IDS_PALETTE_EDIT_MODE: 'Edit mode',
IDS_PALETTE_ACCURACY: 'Number of decimal places',
IDS_PALETTE_DEFAULT: 'Default',
IDS_PALETTE_STEPS_NUM: 'Number of values',
IDS_PALETTE_LEVELS:'Contours',

IDS_GAMMA_CUSTOM:'Custom',
IDS_GAMMA_PHYSYCAL:'Physical',
IDS_GAMMA_BLACK_RED_YELLOW:'Black-Red-Yellow',
IDS_GAMMA_RAINBOW:'Rainbow',
IDS_GAMMA_BLACK_WHITE:'Black and White',

IDS_ISOLINE_COLOR:'Color',
IDS_AVE_PRESS_DESCR:'Formation Pressure',
IDS_KH_DESCR: 'Permeability-Thickness Product',
IDS_OIL_THICKNESS_DESCR: 'Oil Thikcness',
IDS_DEPTH_DESCRIPTION: 'Depth',

IDS_DEGREES:'\u00B0',
IDS_PERF_LEN_SHORT:'Perf. len.',
IDS_PERF_LEN: 'Perforation length',
IDS_CURVE_RADUIS: 'Curve radius',
IDS_DEL_FIRST_BRANCH_POINT_IS_NOT_ALLOWED:'Cannot delete sidetracking point',
IDS_EDITOR_CHOOSE_OBJECT:'Target',
IDS_EDITOR_MODE_MAINWELL:'Well',
IDS_EDITOR_MODE_BRANCH:'Sidetrack',
IDS_WELL_PLACEMENT_PATTERN:'Well placement pattern', // 'Well spacing pattern'
IDS_PAGE_TITLE_WELL_SEARCH:'Candidate Wells',
IDS_CANNOT_ADD_BRANCH_TO_EMPTY_TRAJ:'Cannot create sidetrack for null-trajectory well',
IDS_CANNOT_DRAG_BRANCH_POINT_ON_SECT:'To drag branch point switch to the map view',
IDS_CANNOT_DRAG_BRANCH_POINT:'Cannot drag branch point',
IDS_CANNOT_ADD_BRANCH_TO_BRANCH:'Cannot create sidetrack for another sidetrack',
IDS_CONFIRM_CHOOSE_TRAJ_MODE:'Cannot create new point for trajectory. Turn on Trajector Editor mode?',
IDS_WELL_CHARACTERISTICS:'Well Characteristics',
IDS_TYPE_OF_WELL:'Well Type',
IDS_RADIUS_OF_WELL:'Radius',
IDS_SKIN_FACTOR:'Skin-factor',
IDS_FUNCTION_NOT_IMPLEMENTED_YET:'This function is not implemented yet',
IDS_CANNOT_CALC_PROD_NO_PERF:'Unable to calculate. No perforation intervals are set. Specify perforation intervals for in the panel "Perforation editor"',
IDS_CANNOT_CALC_PROD_NO_PERF_CONDITIONS:'Unable to calculate. Specify conditions for perforation intervals in "Perforation settings" in the settings panel',
IDS_SHOW_TOOLTIP_TVD_MD:'Tooltip TVD, MD',
IDS_SECTION_PLANES:'Section planes',
IDS_WELL_APPEND_POINT:'Append',
IDS_WELL_INSERT_POINT:'Insert',
IDS_WELL_DELETE_POINT:'Delete',
IDS_CALC_PERIOD_MONTH:'month',
IDS_CLEAR:'Clear',
IDS_DELETE_SWEET_SPOT:'Delete Point',
IDS_CREATE_WELL_BY_SWEET_SPOT:'Create Well',
IDS_CALC_WELL_PLACEMENT:'Calculating Well Placement...',
IDS_EFFICIENCY:'Efficiency',
IDS_RATE_START:'Initial oil rate',
IDS_RATE_FINISH:'Final oil rate',
IDS_WELL_PLACEMENT_BHP_GREATER_AVE_PRESSURE:'Bottom hole pressure is higher than formation pressure. Run anyway?',
IDS_WELL_PLACEMENT_BAD_SMALLER_BUBBLE_POINT_PRESSURE:'Bottom hole pressure is smaller than bubble point pressure. Run anyway?',
IDS_WELL_PLACEMENT_STEP_X:'Step along X-axis',
IDS_WELL_PLACEMENT_STEP_Y:'Step along Y-axis',
IDS_RATE_CALCULATION:'Oil rate Calculation',
IDS_RATE_EVALUATION:'Oil rate Evaluation',
IDS_WELL_PLACEMENT_RESULT:'Results',
IDS_RATE: 'Well rate',
IDS_TIME:'time',
IDS_OBJECTS_TREE:'Objects tree',
IDS_MAP:'Map',
IDS_SELECTING_LOW_FORMATION_PRESS_ZONE:'Selecting a low formation pressure zone.',
IDS_PRESS_PLUS_FOR_SELECTING_LOW_FORMATION_PRESS_ZONE:'<p>Press " + " to select low formation pressure zone or ',
IDS_FOR_EDITING_OF_EXIST_ZONE:'edit of an existing one.</p>',
IDS_WELL_LIST:'Well list',
IDS_PROD_WELL_LIST:'Production well list',
IDS_PROD_WELLS_WILL_BE_SEELCTED:'<p>After the low pressure area is determined, production wells located in the specified area will be selected in this list.</p>',
IDS_AVAILABLE_FILTER_LIST:'List of available filters',
IDS_FILTERS_USE_DB_INFO:'<p>Filters use production information stored in a database</p>',
IDS_WELL_STATE_TABLE:'Well state table',
IDS_SHOWS_ALL_INJ_WELLS_STATE:'<p>Shows the status of all injection wells.</p>',
IDS_BY_DEFAULT_PRESS_MAP_SHOWN_RELATIVE_TO_INIT_VALUE:'<p>By default, a reservoir pressure map changes relative to the initial value is shown.</p>',

IDS_REGION_POINTS:'Region points',
IDS_NO_POINTS_IN_REGION:'No points in region!',
IDS_REGION_POINTS_WARNING:'Region boundary should have more than two points!',
IDS_CONVERTED_WELLS:'Converted wells',
IDS_NO_CONVERTED_WELLS:'No converted wells!',
IDS_NO_AIR_ACCESS:'AIR API not available on the server',
IDS_NO_WRITE_ACCESS:'You do not have permission to change data',
IDS_ERROR_RECEIVING_DIAGRAM:'Error getting chart<p>',
IDS_NO_CONNETION_TO_SERVER:'No connection to server <b>ProPlast</b>',
IDS_NO_DATA_SPECIFIED_WELL:'No information for this well<p>&nbsp;',
IDS_SERVER_RETURN_ERROR:'Server <b>ProPlast Data Storage</b> returned error: <p>',
IDS_WELL_NOT_FOUND:'Well not found',
IDS_RESET_FILTER:'Reset filter',
IDS_CREATE_TRAJ:'Create trajectory',
IDS_CALC_SETTINGS:'Settings',
IDS_TRACERS:'Tracers',
IDS_SIMULATION_OF_TRACERS_INJECTION:'Simulation of tracers injection',
IDS_LOW_FORMATION_PRESSURE_ZONES:'Low formation pressure zone',
IDS_PROD_DATA_FILTER:'Production data filter',
IDS_MODEL_DATA_FILTER:'Model data filter',    
IDS_PROD_DATA_OIL_FILTER:'Oil production filter',
IDS_WATER_FLOODING_OPTIMIZATION:'Water flooding optimization',
IDS_OPTIMIZATION:'Optimization',
IDS_REGION:'Region',
IDS_INTERFERENCE_COEF:'Coefficients of interference',
IDS_INJ_WELLS:'Injection wells',
IDS_PROD_WELLS:'Production wells',
IDS_TRANSITION:'Transition',
IDS_TRANSITION_CANDIDATES:'Conversion candidates',
IDS_TRANSITION_OF_PROD_WELLS:'Wells conversion',
IDS_CHOOSE_MODEL_TO_EXPORT_OF_WELL:'Select the model to export the well to',
IDS_CHOOSE_MODEL_TO_IMPORT_OF_WELL:'Select the model to import the well from',
IDS_LOAD_AVAIBLE_WELL_LIST:'Load the list of available wells...',
IDS_CREATING_OF_REGION:'Region creation',
IDS_SWEEP_AREA:'Sweep zone area',
IDS_CONVERT_WELL:'Convert to injector',
IDS_BACK_TO_SETTINGS:'Back to settings',
IDS_LIQ_PROD_TO_BASE:'Change in oil and liquid production relative to the base case',
IDS_CASE_DETAILS:'Variant details',
IDS_CASE_SUMMARY:'Variant summary',
IDS_TRANS_BACK_TO_PROD:'Transfer back to production',
IDS_INIT_PRESS:'Initial pressure',
IDS_TRACERS_INFO:'Tracers info',
IDS_TRACERS_RESULTS:'Tracers results',
IDS_WELLS_FILTER:'Well filter',
IDS_WELLBORE_LEAKAGE:'Wells with wellbore leakage',
IDS_HIST_ANALYSIS_SETT: 'History analysis method settings',
IDS_BOTTOM_HOLE_DZ:'Wells with bottom hole damage zone',
IDS_INEFFECTIVE_INJ:'Wells with ineffective injection',
IDS_WELL_STATUS:'Well status',
IDS_WELL_STATUS_NO_DATA:'No data',
IDS_OPTIMAL_CONDITIONS:'Optimal conditions',
IDS_SUB_OPT_CONDITIONS:'Sub-optimal conditions',
IDS_OPT_NOT_RECOMMENDED:'Optimization not recommended',
IDS_USER_SET_STATUS:'User-set status',
IDS_WELLBORE_LEAKAGE_SHORT:'Wellbore leakage',
IDS_BOTTOM_HOLE_DZ_SHORT:'Bottom hole damage zone',
IDS_INEFFECTIVE_INJ_SHORT:'Ineffective injection',
IDS_WELL_STATUS_INFO:'Status',
IDS_TRACERS_TEST_RESULTS:'Tracers test results',
IDS_HYDRAULIC_STRUCT_PRESS:'Hydraulic fracturing pressure',
IDS_TOOLTIP_MIN_DIST:'min. dist.',
IDS_TOO_CLOSE_TO_ANOTHER_WELL_1:'Distance of the borehole to well',
IDS_TOO_CLOSE_TO_ANOTHER_WELL_2:' is less than the specified limit',
IDS_TOO_CLOSE_TO_FAULT_1: 'Distance to fault ',
IDS_BHP_GRTHEN_RESERVOIR_PRESS:'Bottomhole pressure is higher than formation pressure',
IDS_NO_PERF_BY_FILTER:'Perforations are filtered out',
IDS_ECONOMICAL_EVALUATION:'Profitability estimation',
IDS_TRANSITION_NO_CANDIDATES_YET:'No candidates to show yet',
IDS_TRANSITION_SOME_CANDIDATES_CONVERTED:'Some candidates have been converted already',
IDS_TRANSITION_ALL_CANDIDATES_CONVERTED:'All candidates have been converted already',
IDS_RMS_PROJECT:'Path to the model',
IDS_FILTERS_CAPTION: 'filters',
IDS_NUMERICAL_SETTINGS: 'Simulation settings',
IDS_UNCERTAINTIES_CALCULATION: 'Uncertainties calculation',
IDS_USING_UNCERTAINTIES: 'Using uncertainties',
IDS_AUTO_PRESS_MAINTANCE: 'Auto pressure maintence',
IDS_NO_SHUT_WELLS_IN_OILSATZONE: 'There is no shut wells in oil saturation zone',
IDS_NO_SHUT_WELLS_IN_MODEL: 'There is no shut wells in model',
IDS_NO_FILTERS_SELECTED:'No filters are selected',
IDS_SERACHING_IN_DATABASE:'Searching in database',
IDS_WELLS_FOUND:'Well found',
IDS_WELLS_FOUND_WITH_LEAKS:'\r\n<br> &nbsp;&nbsp;&nbsp; with leakage: <b>',
IDS_WELLS_FOUND_CONTAMINATED:'\r\n<br> &nbsp;&nbsp;&nbsp; contaminated: <b>',
IDS_WELLS_FOUND_INEFFECTIVE:'\r\n<br> &nbsp;&nbsp;&nbsp; ineffective: <b>',
IDS_CONFIRM_CLEAR_WELL_PLACEMENT:'Do you really want to clear target points table?',
IDS_NO_BINDING_DATABASE:'No database binding.\r\nMake binding on browse model page',
IDS_NO_BINDING_FIELD:'No field binding.\r\nMake binding on browse model page',
IDS_NO_BINDING_RESERVOIRES:'No reservoires binding.\r\nMake binding on browse model page',
IDS_NO_BINDING_MODEL:'No data variant binding.\r\nMake binding on browse model page',
IDS_USER:'User',
IDS_CHANGE:'Change',
IDS_OPTION3D_VISUALIZATION:'Visualization',
IDS_INTERFACE:'Interface',
IDS_STATISTICS:'Statistics',
IDS_WELL_CHARTS:'Well Charts',
IDS_CONTOUR_SMOOTHING:'Contour Smoothing',
IDS_COLOR_POINTS_BY_Z:'Color points by Z',
IDS_COLOR_FAULTS_BY_Z:'Color faults by Z',
IDS_WELL_TRAJECTORIES:'Well Trajectories',
IDS_MIN_DISTANCE_BETWEEN_WELLS:'Minimal distance to existed wells',
IDS_OTHER:'Other',
IDS_WELL_DIAGNOSTIC:'Well diagnostics',
IDS_FOR_SET_PERIOD:'for set period',
IDS_PERFS_IN_FLOW_GRID:'Perforation intervals in flow grid',
IDS_WELLVIEW_SCALE:'Scale',
IDS_WELLVIEW_TEMPLATE:'Template',
IDS_CALC_WELL_PLACEMENT_VARIANTS:'Calculate',
IDS_NO_PROP_CHECKED:'No properties are checked',
IDS_NOTHING_IS_SELECTED_FOR_IMPORT:'Nothing is selected for import',
IDS_NO_PRESSURE_PROPERTY_FOUND:'No PRESSURE property found',
IDS_NO_PROJECTS_LOADED_INTO_RV:'No projects loaded into PP',
IDS_NO_PROJECTS_LOADED_INTO_TEMPEST:'No projects loaded into TEMPEST',
IDS_TO_TEMPEST: 'To TEMPEST',
IDS_TO_EXCEL: 'To EXCEL',
IDS_NO_RUNS_IN_THE_TEMPEST_PROJECT: 'No runs in the TEMPEST project',
IDS_INFO_THERE_IS_NO_CALCULATD_VARIANTS:'There is no calculated variants!!!',
IDS_DO_YOU_WANT_KEEP_CURRENT_SESSION:'Do you want to keep using your current session? Answering "No" or cancelling this dialog will open model in new session.',
IDS_COULD_NOT_SAVE_EMPTY_TRAJECTORY_OR_NO_WELL_SELECTED:'Could not save empty trajectory or no well is selected',
IDS_ERROR_GENERATIONG_TRAJECTORY:'Error generating trajectory',
IDS_ERROR_GENERATIONG_PERFORATIONS:'Error generating perforations',
IDS_COULD_NOT_GENERATE_RESULT_FILE:'Error generating results file',
IDS_CHOOSE_WELLS_FOR_TRACERS_CACLULATION:'Select some wells for calculation of tracers',
IDS_NO_INJ_WELL_SELECTED:'Cannot run calcualtion because no injection wells are selected in the table',
IDS_NO_PROD_WELL_SELECTED:'Cannot run calcualtion because no production wells are selected in the table',
IDS_RETURN_TO_PRODUCER:'Return to initial state',
IDS_NO_WELL_SELECTED_FOR_CONVERSION:'No wells are selected for conversion',

IDS_NO_HOR_PROP_FOR_MAP: 'No horizon prop is found for selected map',
IDS_UNKNOWN_MAP: 'Unknown map',
IDS_WELLSRANG_WINDOW_NAME:'Waterflooding optimization',
IDS_CURRENT_DATE: 'Current date',
IDS_TVD: 'Depth',
IDS_PERF_CONDITIONS_CHANGED:'The conditions for perforation intervals of new wells has been changed. Click "Run" button to update the results',
IDS_PERF_CONDITIONS_WILL_BE_APPLIED: 'The conditions for perforation intervals of new wells has been changed. Click "Run" button to apply them',
IDS_SET_DEFAULT_VALUES: 'Default',
IDS_CREATE_REGION: 'Create region',
IDS_CREATE_REGION_BY_VISIBLE_CELLS : 'Create a region by visible cells',
IDS_NEW_REGION: 'New Region',
IDS_CONFIRM_CLEAR_EDITOR_CALC_RESULTS:'Changing the date will cause the loss of the calculated data. Do you really want to change the date?',
IDS_SWEET_SPOT_STATUS: 'Well status',
IDS_SWEET_SPOT_UNKNOWN: 'Unknown',
IDS_SWEET_SPOT_STATUS_LOW_RISKS: 'Low risks',
IDS_SWEET_SPOT_STATUS_MIDDLE_RISKS: 'Middle risks',
IDS_SWEET_SPOT_STATUS_HIGH_RISKS: 'High risks',
IDS_SWEET_SPOT_RISK_SETTINGS: 'Risks settings',
IDS_SWEET_SPOT_EVALUATE_DIST_TO_FAULTS: 'To evaluate distance to faults',
IDS_SWEET_SPOT_DIST_TO_FAULTS: 'Minimal distance to faults',
IDS_SWEET_SPOT_PROFITABILITY_LEVEL: 'Profitability level',
IDS_REGION_DELETE: 'Delete region',
IDS_CONFIRM_CREATE_REGION_AFTER_APPLIED_FILTERS: 'Create a region based on the selected parameters?',
IDS_REGION_CREATED: 'Created region',
IDS_CANNOT_CHANGE_DATE_ON_TRACERS_MODEL_VIEWER: 'To change start date choose another item in "Action" menu',
IDS_PREVIEW: 'Preview',
IDS_APPLY_FILTER:'Apply',// filter',
IDS_ERROR_APPLY_FILTER: 'Before apply the filter is necessary to change its parameters',
IDS_FC_RESET_FILTER: 'Reset',// filter',
IDS_MAP_ACTIONS: 'Maps',
IDS_ERROR_CREATE_REGION: 'Before creating a region is necessary to change the parameters',
IDS_MODEL_STAT: 'For model',
IDS_WELLS_STAT: 'For wells',
IDS_MULTIVARIANT_CALCULATION_SETTINGS: 'Settings',
IDS_MULTIVARIANT_CALCULATION_SETTINGS_EXTRA: 'Other',
IDS_MULTIVARIANT_CALCULATION_ENABLE: 'Calculate uncertainties after calculation',
IDS_WELL_SEARCH_SETTINGS_WELL_PARAMS: 'Well parameters',
IDS_WELL_SEARCH_SETTINGS_PERF_PARAMS: 'Perforation settings',
IDS_WELL_SEARCH_SETTINGS_PERF_FILTERS: '{numProps, plural, =0 {Whole length is perforated } =1 {By property: } other {By properties (#): }}{props}',
IDS_WELL_NO_GO_ZONE_FILTERS: '{numProps, plural, =0 {No restrictions: } =1 {By property } other {By properties (#): }}{props}',
IDS_SWEETSPOT_DISTANCE_TO_FAULT: 'Distance to fault',
IDS_SWEETSPOT_DETAILS_STATUS_BREAKDOWN_HEADER: 'Well status',
IDS_MULTIVARIANT_CALCULATION_PERFORM: 'Calculate',
IDS_MULTIVARIANT_CALCULATION_PERFORMED_CONDITIONS: 'Only calculate for profitable sweetspots',
IDS_MULTIVARIANT_CALCULATION_WARN_NO_SINGLE_YET: 'To perform uncertainty calculation, basic calculation should be performed first.',
IDS_MULTIVARIANT_CALCULATION_WARN_NO_WELLS_SATISFY_CONDITIONS: 'No sweetspots satisfy given conditions',
IDS_PAGE_TITLE_KH:'kh Map',
IDS_PAGE_TITLE_OIL_THICKNESS:'Oil Thickness Map',
IDS_EFFECTIVE_THICKNESS: 'Effective thickness',
IDS_INDEX_BY: 'Index by',
IDS_COORDS_BY: "Coordinates by",
IDS_CANNOT_BE_APPLIED_FILTER: 'Sidetrack length filter can not be applied',
IDS_CHOOSE_ENTRY_POINT: 'Set target point',
IDS_DISTANCE_TO_SWEETSPOT: 'Distance to target point',

IDS_SYMBOL_TRAJ_POS: "Well symbol position",
IDS_SYMBOL_TRAJ_POS_HEAD: "Head",
IDS_SYMBOL_TRAJ_POS_BOTTOM: "Bottom",
IDS_SYMBOL_TRAJ_POS_WELLPICK: "Well pick",

IDS_CANNOT_BUILD_BRANCH_TO_SWEET_SPOT_SIDETRACKING_ANGLE_EXCEEDED: "It is impossible to create side track to selected spot: sidetracking angle is exceeded",
IDS_CANNOT_BUILD_BRANCH_TO_SWEET_SPOT_TRAJECTORY_ENTIRELY_IN_RESERVOIR: "Cannot create sidetrack for specified well because entire trajectory is in the reservoir",
IDS_CANNOT_BUILD_BRANCH_TO_SWEET_SPOT_TRAJECTORY_OUT_OF_GRID: "Cannot create sidetrack for specified well because trajectory is out of reservoir",
IDS_CURVE_LENGTH_EXCEEDED: "Length of the curve exceeds specified limit. Lenght = ",
IDS_CURVE_CURVATURE_EXCEEDED: "Curvature exceeds limit value. Curvature = ",
IDS_BRANCH_TAIL_ANGLE: 'Azimuth',
IDS_IN_INTERVAL: 'In interval',
IDS_OUTSIDE_INTERVAL: 'Outside interval',
IDS_WELLS_LOW_PRODUCTIVITY: 'Low productivity',
IDS_WELLS_HIGH_PRODUCTIVITY: 'High productivity',
IDS_WELLS_LEAKY: 'Leaky',
IDS_TRESHOLD_VALUE_OF_DEBIT: 'Threshold value of the debit',
IDS_INTERVAL: 'Interval',
IDS_HYDRAULIC_FRACTURING: 'Hydraulic fracturing',
IDS_HYDRAULIC_FRACTURING_ABBREVIATION: 'Fracking',
IDS_PLUGIN_LAUNCHED: 'Macro is finished',
IDS_PLUGIN_ERROR_LAUNCHED: 'Error runnning macro',
IDS_USER_PLUGINS: 'User programs',
IDS_BASE_PLUGINS: 'Base programs',

IDS_SHOW_HIDE_ALL_WELL_LABELS: 'Prevent overlapping well labels',
IDS_RUN: 'Run',
IDS_CURVES_NUMBER: 'Number of trajectories',
IDS_AVERAGE_VALUE: 'Average value',
IDS_DEVIATION: 'Deviation',
IDS_PRODUCTION_WELL: 'Production well',
IDS_INJECTOR_WELL: 'Injector well',
IDS_TO_WELLS: 'to wells',
IDS_NORMAL_DISTR: 'Normal',
IDS_SKO: 'Std deviation',
IDS_LOGNORMAL_DISTR: 'Lognormal',
IDS_TRIANGLE_DISTR: 'Triangle',
IDS_KD: 'Corr length',
IDS_DISTRIBUTION_FUNCTION: 'Distribution function',
IDS_STD_DEVIATION: 'Standart deviation',
IDS_CORR_LENGTH: 'Correlation length',
IDS_MINIMAL: 'Minimal value',
IDS_MAXIMAL: 'Maximum value',
IDS_RESERVOIR_THICKNESS: 'Reservoir thickness',
IDS_DECIMAL_QUANTITY: 'fract', // unit fraction
    IDS_ALL_WELLS: 'All wells',
    IDS_PIEZOMETRIC_WELLS: 'Piezometric wells',
IDS_CALC_ANALYSIS: 'Calculation analysis',
IDS_UNCERTAINTIES: 'Uncertainties',
IDS_NO_DATA_SPEARMAN_ANALYS: 'No data for analysis. Need to run calculation first.',
IDS_NO_DATA_INJWELL_INFLUENCE: 'No data. Need to run calculation first.',
IDS_2DPLUS_CALCULATIONS: 'reduced-physics model',
IDS_ANALYTICAL_EXPR: 'Analytical expression',
IDS_FIELD_DATA_ANALYSIS: 'Field data analysis',
IDS_CORRELATION_FACTOR: 'Correlation coefficient',
IDS_SPEARMAN_CORRELATION: 'Spearman correlation',
IDS_EQ_METHODS: 'Compared methods',
IDS_INITIAL_RATE : 'Initial rate',
IDS_NEIGBOURS_STARTING_DEBITS: 'Offset wells starting debit',
IDS_LIQUID_COEFF: 'Liquid',
IDS_OIL_COEFF: 'Oil',
IDS_INFLUENCE_COEFF: 'Influence coefficients',
IDS_WELL_PROPERTIES: 'Properties',
IDS_NO_PROD_WELLS_IN_OILSATZONE: 'There is no production wells in oil saturation zone',
IDS_NO_PROD_WELLS_IN_MODEL: 'There is no production wells in model',
IDS_NO_INJ_WELLS_IN_OILSATZONE: 'There is no injection wells in oil saturation zone',
IDS_NO_INJ_WELLS_IN_MODEL: 'There is no injection wells in model',
IDS_PAGE_TITLE_WELLPLACE_SIDETRACK: 'Sidetrack target points',
IDS_PERC_OF_POINTS_TOO_CLOSE : '% of points too close to another wells',
IDS_PERC_OF_POINTS_HIGH_BHP : '% of points with bhp > reservoir pressure',
IDS_PERC_OF_POINTS_NO_PERF : '% of points do not fit filtering conditions on perforations',
IDS_PERC_OF_POINTS_RESERVES : '% of points filtered out by no-go zone: mobile oil density',
IDS_PERC_OF_POINTS_AV_PRES : '% of points filtered out by no-go zone: average formation pressure',
IDS_MILLI_METERS: 'mm',

IDS_APPLY_PALETTE:'Apply palette',

IDS_MODEL_SUCESSEFULLY_CALCULATED: 'Model successfully calculated',
IDS_MODEL_SUCESSEFULLY_RECALCULATED: 'Model successfully recalculated',

IDS_MACRO_WITH_THAT_NAME_ALREADY_EXIST: 'Macro with that name already exist',
IDS_MACRO_TEXT_INPUT_FIELD: 'Macro text input field',
IDS_ENTER_MACRO_TEXT: 'Enter macro text',
IDS_SELECT_FUNCTION: 'Select a function',
IDS_FUNCTION_DESCRIPTION: 'Function description',
IDS_INSERT_FUNCTON: 'Insert the function',
IDS_DELETE_MACRO: 'Delete macro?',
IDS_CREATE_NEW_MACRO: 'Create new macro',
IDS_MACRO_EDITOR: 'Macro editor',
IDS_RULES: 'Rules',
IDS_EXAMPLE: 'Example',
IDS_EXIT_FROM_MACROEDITOR_WITHOUT_CHANGES_DIALOG: 'Exit the editor without saving changes?',
IDS_DELTA_INJ: 'Injection change',
IDS_BUILD_WELL_BRANCH: 'Build sidetrack',
IDS_REVERSE: 'Reverse',
IDS_PARAMETER: 'Parameter',
IDS_ACCURACY: 'Accuracy',
IDS_LIMIT_VALUES: 'Limit values',
IDS_COUNTOUR_LINES_STEP: 'Contour lines step',
IDS_GENERAL_SETTINGS: 'General settings',
IDS_BUILDING_OF_WELL_BRANCH: 'Building of sidetrack...',
IDS_EVALUATING_OF_WELL_BRANCH: 'Evaluating of sidetrack...',
IDS_SHUT_WELLS: 'Shut wells',
IDS_MODEL_IN_QUEUE_1: 'Model <br>',
IDS_MODEL_IN_QUEUE_2: '<br>added to computation queue\r\n<br>Show the queue execution?',

IDS_SELECT_MODEL_TO_IMPORT_INTO: 'Select a model to export to',
IDS_SELECT_MODEL_FOR_IMPORT: 'Select wells to import',
IDS_WAIT_PLUGIN_TO_FINISH: 'Wait for the plugin running in a separate window to finish.\r\n<br>Please do not load another model in the browser window.',

IDS_WELLS_CONVERSION_FILTER: 'Filter',
IDS_DIST_WELL_TO_SWEET_SPOT_EXCEED_LIMIT: 'Distance from well to target point exceeds max length',
IDS_DIST_TO_WELL_TOO_SMALL: 'Distance of the borehole to well is below the limit',
IDS_WELL_TRAJ_TRUNCATED: 'Trajectory is truncated',
IDS_WELL_HAS_NO_TRAJECTORY: 'Well has no trajectory',
IDS_WELL_CURVE_HOOK_TYPE: 'Trajectory has a U-type shape',
IDS_CURVE_RADIUS_EXCEED: 'Curvature radius less than acceptable value (687 m)',
IDS_SIDE_TRACK_LENGTH_EXCEED: 'Sidetrack length exceed max length',
IDS_CURVE_RADIUS: 'Curve radius',
IDS_CURVE_ERR_UNKNOWN: 'Curve error unknown',
IDS_DIST_EXCEEDED_SHORT: 'Distance exceeded',
IDS_DIST_TO_WELL_TOO_SMALL_SHORT: 'Well too close',
IDS_NO_TRAJ: 'No trajectory',
IDS_BRANCH_NOT_CHOSEN: 'Click the range above, then choose any point in the chart',
IDS_USERDEFINED_PERFORATION: 'Defined by user',
IDS_WELLS_TO_SWEETSPOT_DISTANCE_CALCULATING: 'Calculating distance to target point...',
IDS_OF: 'of',
IDS_WELL: 'Well',
IDS_SEARCH: 'Search',
IDS_NOTHING_FOUND: 'Nothing found',
IDS_PROP_NAME: 'Prop name',
IDS_CREATE_WELL_GROUP: 'Create well group',
IDS_TECHNOLOGICAL_PARAMETERS: 'Technological parameters',
IDS_TYPES: 'Types',
IDS_ACTIVITIES: 'Activities',
IDS_DISTANCE_TO_OWC: 'Minimal distance to OWC',
IDS_DISTANCE: 'Distance',
IDS_GO_ZONE: 'Offset wells area',
IDS_NOT_GRATER_THAN: 'Not greater than',
IDS_TRAJ_CHANGED_CANNOT_OPTIMIZE: 'Trajectory of side tracking has been changed. Unable to run risks evaluation',
IDS_SIDE_TRACKING_ANGLE_SHORT: 'Sidetracking angle',
IDS_SIDE_TRACKING_UPSHIFT_SHORT: 'Sidetracking upshift',
IDS_BHP_UNCHANGEABLE: 'The bhp value is obtained from the model. It is impossible to change it',
IDS_CHANGING_PERF_PROHIBIT_FOR_MODEL_WELL: 'Well is loaded from the model. It is impossible to edit perforation intervals',
IDS_CHANGING_TRAJ_PROHIBIT_FOR_MODEL_WELL: 'Well is loaded from the model. It is impossible to edit its trajectory',
IDS_CHANGING_TRAJ_PROHIBIT_FOR_TRAJ_IJK: 'Real xyz-trajectory of this well is not loaded. It is impossible to edit its trajectory',
IDS_SWEET_SPOT_NOT_DEFINED: 'Entry point is not defined. Select it in "SIDETRACK TARGET POINTS" panel',
IDS_NO_GO_ZONE_CONDITIONS_CHANGED:'No-go zone settings has been changed. Click "Run" button to update the results',
IDS_NO_GO_ZONE_SETTINGS: 'No-go zone filters',
IDS_NO_GO_ZONE_HEADER: 'No-Go Zone filters',
IDS_MODULE_OPTIMIZE_MODELS: 'Development Optimization',
IDS_MODULE_BROWSE_MODELS: '3D Model Analysis',
IDS_MODULE_EDIT_MODELS: 'Well Placement Optimization',
IDS_MODULE_RUN_MACRO: 'Macros and plugins',
IDS_MODULE_PROJECT_MANAGER: 'Project Manager',
IDS_TRAJECTORY_PARAMS: 'Trajectory Params',
IDS_SIDETRACK_CREATED_MANUALLY: 'Sidetrack was created by user or changed',
IDS_CANNOT_CALC_PROD_DISTRIBUTION: 'Cannot compute distribution of productivity',
IDS_SIDETRACK_TAIL_LENGTH: 'Length from T1',
IDS_PERFORATIOS_WILL_BE_LOST: 'Existing perforation intervals will be lost. Continue?',
IDS_FILTER: 'filter',
IDS_FORMATION_PRESSURE: 'Formation Pressure',
IDS_CALCULATING_PRESSURE_BUBBLE_POINT: 'Calculating pressure bubble point...',
IDS_ANTICLINE_TRAP: 'Anticlinal trap reservoir',
IDS_MASSIVE_RESERVOIR: 'Massive reservoir',
IDS_ISOLATED_TRAP: 'Isolated reservoir',
IDS_SOME_PERFS_CHANGED: 'Some perforation intervals have been changed',
IDS_INVALID_SPOT_STEP: 'Invalid value of step',
IDS_UNABLE_PROD_FORECAST: 'Unable to make production forecast. Well is not production',

IDS_SDM_ERR_RESERVES_FILTER: 'Filtered out by no-go zone: mobile oil reserves density',
IDS_SDM_ERR_AV_PRES_FILTER: 'Filtered out by no-go zone: average formation pressure',
IDS_TO_ADD_NEW_SWEET_SPOT_CLICK_MAP: 'Set target point position using double click on the map',
IDS_NO_GO_ZONE_COMPUTATION:  'Computation of no-go zone',
IDS_DAYS: 'days',
IDS_RESERVES_INIT: 'Recoverable reserves',
IDS_RESERVES_FILTER_AV_PRESS: 'Reserves in low formation pressure zone',
IDS_OFFER_WFO: 'of recoverable reserves are in the low formation pressure zone. It is recomended to run water floud optimization procedure. Run calculations without WFO?',
IDS_REGION_STATISTICS_COMPUTATION: 'Computation of statistics of region',
IDS_CANNOT_SHOW_NO_GO_ZONE_ON_STRUCT: 'Cannot show no-go zone on the structure map',
IDS_CANNOT_SHOW_NO_GO_ZONE_ON_HORIZON: 'Cannot show no-go zone on this horizon',
IDS_VISCOSITY_SETTINGS: 'Viscosity',
IDS_BOUNDARY_PRESSURE: 'Formation boundary pressure',
IDS_BOUNDARY_PRESSURE_TOLERANCE: 'tolerance',
IDS_NO_2D_GRID_IN_RDS_MODEL: '2D grid is not found in RDS for the selected Data variant.\r\nSelect another Data variant or create a 2D grid in the Database application.',
IDS_2D_GRID: '2D-grid',
IDS_NO_DATE_CHOOSEN: 'No date chosen',
IDS_INJECTIVITY_DEBIT: 'Injectivity/Debit',
IDS_CANNOT_CALC_INJ_WELL:          "The selected well is injector. Do you really want to continue?",
IDS_CANNOT_CALC_SHUT_WELL:         "The selected well is shut. Do you really want to continue?",
IDS_CANNOT_CALC_STOP_WELL:         "The selected well is stopped. Do you really want to continue?",
IDS_CANNOT_CALC_GAS_WELL:          "The selected well is gas. Do you really want to continue?",
IDS_CANNOT_CALC_UNKNOWN_WELL:      "The selected well is unknown. Do you really want to continue?",
IDS_STOPPED_WELL: "Stopped",
IDS_FILTERS_APPLIED_TO_REGION: 'Filters apply to region ',
IDS_EDITING_PROHIBITED_WRONG_MODE: 'Impossible to edit well. Turn Trajector Editor mode or Perforation Editor mode on',
IDS_EDITING_PROHIBITED_WELL_MODE_BRANCH_SELECTED: 'Impossible to edit sidetracking because well editor mode was selected',
IDS_EDITING_PROHIBITED_SIDETRACKING_MODE_WELL_SELECTED: 'Impossible to edit well because sidetracking editor mode was selected',
IDS_TARGET_POINT_DEBIT_TOO_SMALL: 'Debit value in selected target point is too small',
IDS_SIDETRACK_NO_DEBIT: 'Sidetrack debit value in selected target point is too small',
IDS_TREAT_SWEET_SPOT: 'Treat',
IDS_TREAT_FRACKING: 'Fracking',
IDS_NO_SETTINGS_SET: 'Setting value is incorrect: ',
IDS_PRESS_APPLY_TO_UPDATE_BRANCH: 'Press "Apply" to save changes',
IDS_RESET_SUGGESTED_BRANCH: 'Reset',

IDS_CONFIRM_CREATE_TRAJ: 'All trajectory points except the first one will be deleted. Continue?',
IDS_FILTERS_APPLY_TO_REGION_1: "Cells outside region '",
IDS_FILTERS_APPLY_TO_REGION_2: "' should not be perforated",
IDS_ALL_CANDIDATES_ALREADY_CALCULATED: 'All candidates already calculated',

IDS_SDM_ERR_OUT_OF_OIL_SAT_ZONE: 'Specified well has no perforation in the current region',
IDS_SDM_ERR_OUT_OF_OIL_SAT_ZONE_TRJ: 'Specified well has no trajectory in the current region',
IDS_FILTRATION_INF_ONE_CELL_SHUT: 'Specified well will be shut. There are another well in the same cell:',
IDS_SDM_ERR_OUT_OF_DATA_VARIANT: 'Specified well has no perforation in the selected data variant',

IDS_HYDRODYNAMC_MODEL_INFO: 'Информация по гидродинамической модели',
IDS_DB_PROD_INFO: 'Информация по источнику промысловой информации. Эксплутационный объект - ',
IDS_THICKNESS: 'Thickness',
IDS_EFF_THICKNESS: 'Effective thickness',
IDS_NET_TO_GROSS: 'Net-to-gross',
IDS_CURRENT_SOIL: 'Current oil saturation',

IDS_WATER_CUT_EVALUATION: 'Water cut evaluation',
IDS_BY_OFFSET_WELLS: 'By offset wells',
IDS_BY_CURRENT_OIL_SATURATION: 'By oil saturation',

IDS_SDM_ERR_NO_TRAJ:'The well has no trajectory',
IDS_SDM_ERR_NO_PERF:'There is no perforation at the well',
IDS_SDM_ERR_MULT_ZERO:'The well-reservoir multiplier is zero',
IDS_SDM_ERR_NO_TRAJS:'Some wells do not have a trajectory',

IDS_SDM_TOO_CLOSE_TO_ANOTHER_SPOT: "Too close to a SPOT",
IDS_SDM_NO_HD_MODEL:'No reduced-physics model in the project',

IDS_WELLS_WORK_REGIME: 'Wells work regime',
IDS_FORMATION_PRESSURE_CALCULATION_RESULTS: 'Сalculation result',
IDS_FORMATION_PRESSURE_EVALUATION: 'Formation Pressure. Evaluation', // at fluid contact?
IDS_FORMATION_PRESSURE_CALCULATION: 'Calculation', // на контакт флюидов?
IDS_FORMATION_PRESSURE_HYDRODYNAMIC_CALCULATION: 'Hydrodynamical calculation', // на контакт флюидов?
IDS_FORMATION_PRESSURE_CORRECTION: 'Correction', // на контакт флюидов?
IDS_FORMATION_PRESSURE_DEVIATION: 'Deviation',
IDS_CALCULATE_INTERFERENCE_COEF:'Calculate coefficients of interference',
IDS_CUTOFF_ANGLE_45: 'Cut-off angle 45 deg.',
IDS_CUTOFF_ANGLE_90: 'Cut-off angle 90 deg.',
IDS_SEVERAL_CALCULATIONS_RUNNING_CLICK_ICON_TO_SHOW: 'Several calculations are still running. Click the icon to show list.',
IDS_CANNOT_TRANSIT_WELL_LOW_PRESS_AUTO_HFA: 'Cannot transit the well because auto-HFA pressure is too low.',
IDS_WELLS_INTERFERENCE: 'Interference of wells',
IDS_3D_SIMULATING: '3D-simulating',
IDS_FORMATION_PROPERTIES: 'Formation properties',
IDS_SIMPLIFIED_MODEL: 'Simplified model',
IDS_BOUNDARY_CONDITIONS: 'Boundary conditions',
IDS_NO_DATABASE_WELLS_FOUND: 'No database wells found!',
IDS_NO_CANDIDATE_FOR_UNCERTAINTY_CALCULATION: 'There is no candidate for uncertainty calculation!',
IDS_NO_DATA_SHORT: 'no data',
IDS_CALC_AREA: 'Calсulation area',
IDS_SELECTION: 'Selection',
IDS_VISIBLE_CELLS: 'Visible cells',
IDS_BHP_CLOSE_TO_PRES: 'The bottom hole pressure becomes greater than the reservoir pressure. The well is turned off during the first month',

IDS_NO_WLPR_NO_WWIR_IN_DATABASE: 'The database does not contain data either on liquid debit or injectivity',
IDS_CALC_TARGET_POINT: 'Calculating of target point...',
IDS__SDM_NO_BHP: 'There is no Bottom hole pressure on this well. It is not used in the calculation',
IDS_TARGET_POINT_WELL_CHARACTERISTICS:'Prototype well info',
IDS_TARGET_POINT_SIDETRACK_CHARACTERISTICS:'Prototype sidetrack info',
IDS_GRADIENT_FILL: 'Gradient fill',
IDS_AVE_PRESSURE:'Average pressure',
IDS_CALC_PERM: 'Calculate',
IDS_CALC_PERM_METHOD: 'Calculation method',
IDS_INTERPOLATION_METHOD_RADIAL: 'Radial',
IDS_UNCERTAINTY_INPUT_PARAMS: 'Uncertainty of input parameters',

IDS_COMMUNICATION_ERROR: 'Error occurred during data exchange',

IDS_CREATE_GRID3D_PARAMS: 'Grid parameters',
IDS_NX: 'Size anong X-axis',
IDS_NY: 'Size anong Y-axis',
IDS_NZ: 'Size anong Z-axis',
IDS_PLASTIC_DEFORMATION_FORM: 'Plastic deformation form',
IDS_PLASTIC_DEFORMATION_FORM_PROPORTIONAL: 'Proportional',
IDS_BUILDING_OF_GRID3D: 'Building of 3D-grid...',
IDS_GRID3D_SUCCESSFULLY_BUILT: '3D-grid is succesfully built',
IDS_INCORRECT_PERF_INTERVAL: 'Perforation interval is not correct',

IDS_LOG: 'Log',


// ====================================== Quick Tour =====================================
IDS_WELLS: 'скважины',
IDS_SIDETRACKS: 'боковые стволы',
IDS_WELL_GENITIVE: 'скважины',
IDS_SIDETRACK_GENITIVE: 'бокового ствола',
IDS_WELLS_GENITIVE: 'скважин',
IDS_SIDETRACKS_GENITIVE: 'боковых стволов',
IDS_WELL_ACCUSATIVE: 'скважину',
IDS_SIDETRACK_ACCUSATIVE: 'боковой ствол',
IDS_WELLS_PREPOSITIONAL: 'скважинах',
IDS_SIDETRACKS_PREPOSITIONAL: 'боковых стволах',
IDS_PROJECTED_WELL_GENITIVE: 'проектируемой скважины',
IDS_PROJECTED_SIDETRACK_GENITIVE: 'проектируемого бокового ствола',
IDS_NEW_WELL_GENITIVE: 'новой скважины',
IDS_NEW_SIDETRACK_GENITIVE: 'нового бокового ствола',
IDS_PROJECTED_WELL_PREPOSITIONAL: 'проектируемой скважине',
IDS_PROJECTED_SIDETRACK_PREPOSITIONAL: 'проектируемом боковом стволе',
IDS_LOADED_GENITIVE_FEMALE_SINGLE: 'загруженной',
IDS_LOADED_GENITIVE_MALE_SINGLE: 'загруженного',
IDS_NEW_GENITIVE_FEMALE: 'новой',
IDS_NEW_GENITIVE_MALE: 'нового',
IDS_IT_FEMALE: 'она',
IDS_IT_MALE: 'он',
IDS_WELL_PLANNED_GENITIVE: 'планируемой скважины',
IDS_SIDETRACK_PLANNED_GENITIVE: 'планируемого бокового ствола',
IDS_DIAGRAM_ACCUSATIVE: 'диаграмму',
IDS_SECTION_ACCUSATIVE: 'разрез',


IDS_TOUR_SWEET_SPOTS_SUMMARY_TITLE:'Оценка местоположения {0}',
IDS_TOUR_SWEET_SPOTS_SUMMARY_TEXT:
    'В этом модуле проводится поиск потенциальных мест для бурения новых {0}. '+
    '<p>'+
    '<p>Поиск осуществляется с помощью расчетов на модели с упрощенной физикой и анализе промысловых данных. '+
    '<p>'+
    '<p>Критерием оптимальности выбранного места являются оценки стартового дебита новых {0}.',
IDS_TOUR_SWEET_SPOTS_CALC_SETTINGS_TITLE: 'Настройки расчета',
IDS_TOUR_SWEET_SPOTS_CALC_SETTINGS_TEXT_1W:
    'На первом этапе необходимо выбрать тип траектории проектируемой скважины: вертикальная или '+
    'горизонтальная. Также можно задать следующие параметры: ',
IDS_TOUR_SWEET_SPOTS_CALC_SETTINGS_TEXT_1ST:
    'Здесь можно задать следующие параметры: ',
IDS_TOUR_SWEET_SPOTS_CALC_SETTINGS_TEXT_2:
    '<p>' +
    '<p>Значение <b>забойного давления</b>, которое будет выставляться на всех проектируемых ' +
    'скважинах в процессе оптимизации. ' +
    '<p><b>Условия для перфораций</b> стволов. ' +
    '<p><b>Область поиска</b> местоположения проектируемых {0}. '+
    '<p><b>Прочие</b> настройки. ',
IDS_TOUR_SWEET_SPOTS_SETTINGS_PERF_FILTER_TITLE: 'Настройки перфораций',
IDS_TOUR_SWEET_SPOTS_SETTINGS_PERF_FILTER_TEXT:
    'Для того, чтобы проектируемые скважины были проперфорированы, необходимо включить '+
    'хотя бы один из нижеуказанных фильтров. Интервалы перфораций будут определятся наложением, '+
    'используемых фильтров. '+
    '<p>',
IDS_TOUR_SWEET_SPOTS_SETTINGS_NOGO_ZONE_TITLE: 'Область поиска',
IDS_TOUR_SWEET_SPOTS_SETTINGS_NOGO_ZONE_TEXT:
    '<p>Данная настройка не является обязательной, но позволяет значительно ускорить поиск '+
    'оптимальных мест для бурения новых скважин. </p>'+
    '<p><b>Плотность мобильных запасов</b>. Ячейки, которые не '+
    'удовлетворяют условию фильтра, закрашиваются серым цветом. </p>'+
    '<p><b>Среднее пластовое давление</b>. Ячейки, которые не '+
    'удовлетворяют условию фильтра, изображаются полупрозрачными. <p>'+
    '<p><b>Минимальное расстояние до существующих скважин</b>. Ячейки, которые не '+
    'удовлетворяют условию фильтра, закрашиваются серым цветом. <p>'+
    '<p>Ниже выводится информация о количестве <b>Извлекаемых запасов</b>, '+
    'рассчитываемых с учетом фильтра <b>Плотность мобильных запасов</b> и '+
    '<b>Запасов в зоне пониженного давления</b>. Последние рассчитываются по "полупрозрачным '+
    'ячейкам, т. е. по той области, в которой условие фильтра <b>Среднее пластовое '+
    'давление</b> не выполняется. <p>',
IDS_TOUR_SWEET_SPOTS_SETTINGS_MORE_TITLE:'Прочие',
IDS_TOUR_SWEET_SPOTS_SETTINGS_MORE_TEXT:
    'В этом разделе можно указать: '+
    '<p>'+
    '<p><b>Максимальное количество вариантов.</b> Т. е. предельное количество проектируемых {0}.'+
    '<p><b>Настройки численного метода</b>. ' +
    '<p>Производить ли в ходе вычислений <b>расчет неопределенностей</b> или нет. ',
IDS_TOUR_SWEET_SPOTS_SETTINGS_SIMULATION_SETTINGS_TITLE: 'Настройки численного метода ',
IDS_TOUR_SWEET_SPOTS_SETTINGS_SIMULATION_SETTINGS_TEXT:
    '',
IDS_TOUR_SWEET_SPOTS_RESULTS_TABLE_TITLE:
    'Продуктивность',
    IDS_TOUR_SWEET_SPOTS_RESULTS_TABLE_TEXT:
    'В таблице представлены результаты расчета стартовых дебитов новых {0}. '+
    '<p>'+
    '<p>В колонке «<b>Модель с упрощенной физикой</b>» показывается значение стартового дебита {1}'+
    ', рассчитанного с помощью упрощенной гидродинамической модели. '+
    '<p>В колонке «<b>Аналитические оценки</b>» показывается значение стартового '+
    'дебита {2}, полученное на основе аналитического решения уравнения '+
    'притока и промысловых данных. '+
    '<p>В колонке «<b>Анализ данных</b>» приводится оценка стартового дебита {3}'+
    ' на основе данных о стартовых дебитах соседних скважин. Этот метод основан только на '+
    'данных и не использует знания законов фильтрации.'+
    '<p>Дополнительную информацию о {4} можно получить через контекстное меню. ',
IDS_TOUR_SWEET_SPOTS_SETTINGS_CLASSIFICATION_TEXT:
    'В этом разделе задаются критерии, которые будут использоваться при оценке риска ' +
    'бурения новых скважин.',

IDS_TOUR_START_PAGE_TITLE: 'Начало работы',
IDS_TOUR_START_PAGE_TEXT: 'Для начала работы необходимо выбрать проект слева в дереве проектов',

IDS_TOUR_PROJECT_PAGE_TEXT:
    'В центре экрана вы можете увидеть краткую информацию о выбранной модели.'+
    '<p>'+
    '<p>Ниже можно посмотреть и/или сгенерировать отчетные документы, а также ознакомиться с сопроводительными '+
    'файлами и документами, находящимися в папке с выбранной гидродинамической моделью.'+
    '<p>'+
    'В правой панели располагаются кнопки для работы с различными модулями программы:',

IDS_TOUR_3D_MODEL_ANALYSIS_TITLE_1: 'Анализ 3D моделей ',
IDS_TOUR_3D_MODEL_ANALYSIS_TEXT_1: 
    '<p>Приложение предназначено для визуализации и анализа гидродинамических и '+
    'геологических моделей, которые находятся в хранилище.</p>'+
    '<p>В локальной версии программы путь на хранилище можно установить с помощью '+
    'специальной настройки на стартовой странице приложения.</p>'+
    '<p>В online версии путь на хранилище устанавливает администратор.</p>',
IDS_TOUR_3D_MODEL_ANALYSIS_TITLE_2: 'Общая структура приложения',
IDS_TOUR_3D_MODEL_ANALYSIS_TEXT_2: 
    '<p>Рабочее поле этой страницы состоит из трех панелей: </p>'+
    '<ul>'+
    '<li><b>Левая панель</b>. Список моделей, имеющихся в хранилище данных.</li>'+
    '<li><b>Центральная панель</b>. Содержит краткую информацию о модели, а также отчетные документы и сопроводительные файлы.</li>'+
    '<li><b>Правая панель</b>. Список инструментов для работы с 3D моделями.</li>'+
    '</ul>'+
    'Для начала работы необходимо выбрать проект на левой панели инструмент анализа (например 3D визуализация).',
IDS_TOUR_3D_MODEL_ANALYSIS_TITLE_3: 'Отчетные документы ',    
IDS_TOUR_3D_MODEL_ANALYSIS_TEXT_3:   
    '<p>Отчетные документы вычисляются с помощью плагинов, которые вызываются с '+
    'помощью команды Расcчитать. Если есть необходимость в обновлении отчетных '+
    'документов, то нужно выбрать команду Пересчитать</p>',
IDS_TOUR_3D_MODEL_ANALYSIS_TITLE_4: 'Начало работы ',
IDS_TOUR_3D_MODEL_ANALYSIS_TEXT_4: 
    '<p>Для начала работы необходимо выбрать один из инструментов на правой панели. '+
    'При этом происходит загрузка выбранной модели в оперативную память сервера. </p>',
        
IDS_TOUR_3D_MODEL_ANALYSIS_MAP_SETTINGS_TITLE: 'Настройка визуализации карт',
IDS_TOUR_3D_MODEL_ANALYSIS_MAP_SETTINGS_TEXT_1: 
    'Нажмите кнопку с изображением шестеренки для получения списка настроек отображения карты',
IDS_TOUR_3D_MODEL_ANALYSIS_MAP_SETTINGS_TEXT_2: 
    'Для изменения цвета круговой диаграммы необходимо кликните левой кнопкой мышки на '+
    'соответствующее обозначение в панели <b>Условные обозначения</b>.',
IDS_TOUR_3D_MODEL_ANALYSIS_PALETTE_SETTINGS_TITLE: 'Настройка цветовой палитры ',
IDS_TOUR_3D_MODEL_ANALYSIS_PALETTE_SETTINGS_TEXT: 
    '<li>Для изменения цветовой палитры необходимо навести курсор мышки на цветовую шкалу '+
    'и сделать двойной щелчок</li>.'+
    '<li>В появившейся справа панели настроек можно отредактировать цветовую палитру.</li> '+ 
    '<li>Для фиксации изменений нужно нажать кнопку <b>Применить</b></li>. ',

IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_TITLE: 'Оптимизация положения скважин',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_TEXT: 'Данный модуль предоставляет средства для решения следующих задач:'+
    '<p>'+
    '<ul>'+
    '<li>Поиск оптимальных мест для уплотняющего бурения и оценка продуктивности новых скважин. Для этого следует нажать кнопку <b>Скважина</b>.</li>'+
    '<li>Поиск скважин для зарезки боковых стволов и оценка продуктивности бокового ствола. Этой задаче отвечает кнопка <b>Боковой ствол</b>.</li>'+
    '</ul>',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_WELL_TITLE_1: 'Общая структура приложения',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_BRANCH_TITLE_1: 'Последовательность действий',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_WELL_TEXT_1: 
    '<p>Рабочее поле приложения состоит из трех панелей: </p>'+ 
    '<ul>'+
    '<li>Левая панель. Дерево данных, содержащее список скважин и карт свойств пласта; </li>'+
    '<li>Центральная панель. Область для визуализации карт, разрезов и для создания комбинированных видов; </li>'+
    '<li>Правая панель. Список необходимых команд и настроек для оптимизации расстановки новых скважин. </li>'+
    '</ul>',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_WELL_TITLE_2: 'Последовательность действий',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_BRANCH_TITLE_2: 'Последовательность действий',
IDS_TOUR_PROJECT_PAGE_WELL_PLACEMENT_OPTIMIZATION_WELL_TEXT_2: 
    '<p>На этой странице представлена последовательность действий для решения задачи оптимизации '+
    'уплотняющего бурения. </p>'+
    '<ul>'+
    '<li><b>Оценка местоположения скважины</b>. Поиск оптимальных мест для бурения проектируемых '+
    'скважин на основании оценки стартового дебита.</li>'+
    '<li><b>Редактор траектории</b>. Просмотр и редактирование траекторию проектируемой скважины.</li>'+
    '<li><b>Редактор перфораций</b>. Просмотр и редактирование перфорации проектируемой скважины.</li>'+
    '<li><b>Прогноз добычи</b>. Расчет среднесрочного профиля добычи проектируемой скважины '+
    'с помощью упрощенного гидродинамического моделирования.</li>'+
    '</ul>'+
    '<p>Обязательным действием явлется оценка местоположения скважины. </p>',
IDS_TOUR_PROJECT_PAGE_MODEL_ANALYSIS:
    '<ul><li>3D визуализация</li>'+
    '<li>Технологические показатели</li>'+
    '<li>Разрез</li>'+
    '<li>Рассчитать</li>'+
    '</ul>',
IDS_TOUR_PROJECT_PAGE_EDIT_MODELS:
    '<ul><li>Скважина</li>'+
    '<li>Боковой ствол</li>'+
    '</ul>',
IDS_TOUR_PROJECT_PAGE_OPTIMIZE_MODELS: '<ul><li>Области пониженного давления</li>'+
    '<li>Фильтр по промысловым данным</li>'+
    '<li>Фильтр по модельным данным</li>'+
    '<li>Перевод скважин</li>'+
    '<li>Оптимизация ППД</li></ul>',
IDS_TOUR_PROJECT_PAGE_RUN_MACRO: 'Редактирование и запуск макросов',
IDS_TOUR_WELLS_STAT_TEMPLATES_TITLE: 'Выбор типа выводимых данных',
IDS_TOUR_WELLS_STAT_TEMPLATES_TEXT: 'Выберите тип данных для вывода информации на кроссплот',
IDS_TOUR_WELLS_SLIDER_DEBIT_TITLE: 'Настройка порогового значения дебита',
IDS_TOUR_WELLS_SLIDER_DEBITS_TEXT: 'Настройте пороговое значение дебита для опредения скважин к группам низкодебитных и высокодебитных',
IDS_TOUR_WELLS_SKIRT_INTERVAL_TITLE: 'Настройка интервала отклонения',
IDS_TOUR_WELLS_SKIRT_INTERVAL_TEXT: 'Выберите величину допустимого интервала отклонения расчетного значения от фактического значения для групп низкодебитных и высокодебитных скважин',
IDS_TOUR_WELLS_TABLE_TITLE: 'Таблица со статистикой по скважинам',
IDS_TOUR_WELLS_TABLE_TEXT: '"Всего" - общее количество скважин в группе, "В интервале" - количество скважин внутри интервала отклонения, "Вне интервала - количество скважин за пределами интервала отклонения"',
//IDS_TOUR_WELLSEARCH_FILTERS_TEXT: 'Фильтры позволяют выбрать из списка всех добывающих скважин те, которые наилучшим образом подходят для врезки бокового ствола. После того, как нужная скважина выбрана, дается команда начать боковой ствол.',
IDS_TOUR_WELLSEARCH_FILTERS_TEXT:
'<p>В разделе «Фильтр по скважинам» можно задать один или несколько критериев для таких скважин:</p>'+
'<ul>'+
'<li>дебит нефти;</li>'+
'<li>обводненность</li>'+
'<li>диаметр колонны</li>'+
'<li>расстояние до T1</li>'+
'<ul>'+
'<p>Нажмите «Рассчитать». Запустится процесс оценки возможности зарезки бокового ствола с пробуриванием его в выбранную целевую точку. </p>',
IDS_TOUR_WELLSEARCH_TABLE:
'<p>В таблице «Добывающие скважины» отобразится список всех возможных скважин для зарезки бокового ствола. Скважины, для которых выбранные в разделе фильтров условия будут удовлетворены, будут отмечены в таблице зеленым кружком, остальные красным.',

IDS_TOUR_3D_VISUALIZATION_SUMMARY_TITLE: 'Общая структура модуля', 
IDS_TOUR_3D_VISUALIZATION_SUMMARY_TEXT: 
    '<p>В левой панели представлены все объекты, имеющиеся в модели: </p>'+ 
    '<ul>'+
  '<li><b>Статические</b> и <b>Динамические</b> 3D параметры.</li>'+ 
  '<li><b>Карты</b>. Рассчитываются путем осреднения трехмерных параметров. </li>'+
  '<li><b>Скважины</b>.</li>'+
  '<li><b>Регионы</b>. Регион представляет собой набор произвольного количества ячеек модели. Например '+
    'это могут быть ячейки, входящие в нефтенасыщенную зону или регионы инициализации. </li>'+
    '</ul>',
IDS_TOUR_3D_VISUALIZATION_CUBES_TITLE: 'Выбор параметра для визуализации',
IDS_TOUR_3D_VISUALIZATION_CUBES_TEXT: 
    'В дереве данных откройте раздел <b>Статические параметры</b> или <b>Динамические параметры</b> и выберите '+
    'интересующее свойство. Его визуализация происходит автоматически. Также, в качестве '+
    'отображаемого можно выбрать и <b>Структуру</b>.',
IDS_TOUR_3D_VISUALIZATION_CELL_FILTER_TITLE: 'Фильтр по ячейкам',
IDS_TOUR_3D_VISUALIZATION_CELL_FILTER_TEXT: 
    '<ul>'+
    '<p><li>Раскройте один из разделов: <b>Геометрия сетки</b>, <b>Статические параметры</b> или <b>Динамические параметры</b> '+
    'и отметьте тот, по которому требуется установить фильтр. Можно выбрать несколько параметров. При этом в загаловке '+
    'раздела отобразится количество выбранных параметрв.</li></p>'+
    '<p><li>Задайте требуемый диапазон значений параметра, передвигая ползунки слайдера либо вводя значения '+
    'в соответствующие поля ввода.</li></p>'+
    '<p><li>Для подтверждения нажмите <b>Применить фильтр</b>. Для сброса фильтров нажмите '+
    '<b>Сбросить фильтр</b>. </li></p>'+
    '<ul>',
IDS_TOUR_3D_VISUALIZATION_CREATE_REGION_TITLE: 'Создание региона по видимым ячейкам',
IDS_TOUR_3D_VISUALIZATION_CREATE_REGION_TEXT: 
    'Для создания региона по видимым ячейкам нажмите <b>Создать регион '+
    'по видимым ячейкам</b> после настройки параметров либо после '+
    'применения фильтра. В правом нижнем углу правой панели появится '+
    'уведомление о создании региона.',
IDS_TOUR_3D_VISUALIZATION_REGIONS_TITLE: 'Список регионов',
IDS_TOUR_3D_VISUALIZATION_REGIONS_TEXT: 
    '<p>Созданный регион появится в списке регионов. Переименовать '+
    'или удалить регион можно через контекстное меню, открывающееся по правой '+
    'кнопке мышки или по значку <b>⋮</b>. </p>'+
    '<p>Создать регион также возможно, нажав кнопку <b>+</b>. </p>',

IDS_TOUR_3D_SECTION_SUMMARY_TITLE: 'Разрез',
IDS_TOUR_3D_SECTION_SUMMARY_TEXT: 
    '<p>'+
    'Модуль предназначен для построения и визуализации разрезов по скважинам, '+
    'а также для редактирования свойств ячеек, пересекаемых скважинами (blocked wells).'+
    '</p>'+
    '<p>'+
    'Модуль позволяет визуализировать: '+
    '</p>'+    
    '<ul>'+    
    '<li>Разрезы, расcчитанные по геолого-гидродинамической модели.</li>'+
    '<li>Трехмерное представление профиля разреза.</li>'+
    '<li>Планшет по скважинам и результаты интерпретации ГИС (РИГИС).</li>'+
    '</ul>',
IDS_TOUR_3D_SECTION_DESKTOP_TITLE: 'Рабочее поле',
IDS_TOUR_3D_SECTION_DESKTOP_TEXT: 
    '<p>'+
    'Рабочее поле модуля состоит из трех частей: '+
    '</p>'+
    '<ul>'+    
    '<li><b>Левая часть</b> содержит дерево данных, в котором выбираются объекты для отображения '+
         'на разрезе. Такими объектами являются скважины и поверхности. </li>'+
    '<li><b>Центральная часть</b> содержит визуализацию разреза.</li>'+
    '<li><b>Правая часть</b> содержит панель инструментов и информацию о выбранном объекте.</li>'+
    '</ul>'+
    '<p>'+
    'Выбранные настройки действуют только в рамках данного модуля и не влияют на работу '+
    'других модулей приложения.'+    
    '</p>',
IDS_TOUR_3D_SECTION_ADD_WELL_TITLE: 'Добавление скважин на разрез',    
IDS_TOUR_3D_SECTION_ADD_WELL_TEXT:
    '<ul>'+
    '<li>В дереве данных откройте раздел <b>Скважины</b>.</li>'+
    '<li>Выберите одну из скважин и нажмите мышкой на значек <b>⋮</b> справа от ее имени.</li>'+
    '<li>Выполните команду <b>Добавить на {0}</b>.</li>'+
    '</ul>'+
    '<p>'+
    'Разрез отображается в центральной панели модуля. По умолчанию, '+
    'выбранные скважины визуализируется на разрезе по геолого-гидродинамической модели. '+
    '</p>',
IDS_TOUR_3D_SECTION_VIEW_TYPE_TITLE: 'Способы отображения разреза',
IDS_TOUR_3D_SECTION_VIEW_TYPE_TEXT:
    '<p>'+
    'Переключение между различными видами визуализации осуществляется с помощью команд '+
    'на панели инструментов.'+
    '</p>',
IDS_TOUR_3D_SECTION_EDIT_TITLE: 'Редактирование свойств ячеек',
IDS_TOUR_3D_SECTION_EDIT_TEXT:     
    '<p>'+
    'Для изменения свойств ячеек используйте инструмент <b>Калькулятор</b>. Перед началом '+
    'работы убедитесь, что инструмент включен в настройках модуля.'+
    '</p>'+
    '<p>'+
    'В командной строке калькулятора введите арифметическое выражение и выполните команду. '+
    'Указанное выражение будет применено ко всем выделенным ячейкам. Если ячейки не выделены, '+
    'операция будет выполнена для всей модели.'+
    '</p>',
IDS_TOUR_3D_SECTION_SELECT_TITLE: 'Выделение ячеек',
IDS_TOUR_3D_SECTION_SELECT_TEXT: 
    '<p>'+
    'Выделение ячеек может выполняться с помощью инструмента <b>Диаграмма скважины</b>, который '+
    'необходимо предварительно включить в настройках модуля.'+
    '</p>'+
    '<p>'+
    'Чтобы выделить ячейки, нажмите и удерживайте левую кнопку мыши, затем выделите на '+
    'диаграмме скважины требуемый диапазон глубин. Соответствующие ячейки на разрезе '+
    'модели будут выделены автоматически.'+
    '</p>'+
    '<p>'+
    'После выделения к выбранным ячейкам можно применить операции калькулятора.'+
    '</p>',

IDS_TOUR_WELL_CONVERSION: 'Перевод скважин',
IDS_TOUR_WELL_CONVERSION_SUMMARY:
'<p>Перевод скважин в нагнетание является одним из методов для оптимизации системы заводнения и поддержания пластового давления. Данный модуль позволяет найти добывающие и остановленные скважины, перевод которых в нагнетание даст наибольший прирост в добыче. Для этого необходимо выполнить следующие действия.</p>'+
'<h3>Выбрать скважины кандидаты для перевода в нагнетание</h3>'+
'<p>Скважины кандидаты выбираются из списков добывающих и остановленных скважин. Выбор добывающих скважин может быть сделан вручную или с помощью специальных фильтров. Остановленные скважины выбираются из соответствующего списка вручную. </p>'+
'<ul>'+
'<li>Фильтр по дебиту скважин</li>'+
'<li>Фильтр по обводненности</li>'+
'</ul>'+
'<h3>Задать настройки расчета</h3>'+
'<p>Для проведения расчетов необходимо задать следующие настройки.</p>'+
'<ul>'+
'<li><b>Задать минимальное и максимальное значение приемистости.</b> Эта насройка задает пределы, в которых может изменятся приемистость скважины после ее перевода в нагнетание.</li>'+
'<li><b>Количество вариантов.</b> Определяет количество значений, на которые разбивается выбранный интервал приемистости. Если количество вариантов равно двум, то приемистость переведенной скважины будет принимать значения равные верхней и нижней границы интервала </li>'+
'<li><b>Давление авто ГРП.</b> Этот параметр определяет максимальное забойное давление, которое может быть на скважине при ее работе после перевода в нагнетание. Если забойное давление будет превышать давление авто ГРП, то контроль скважин будет осуществляться по забойному давлению равному давлению авто ГРП.</li>'+
'</ul>'+
'<h3>Проведение расчетов</h3>'+
'<p> Для проведения расчетов нужно выбрать команду РАССЧИТАТЬ в разделе Действия. Скважины кандидаты поочередно переводятся в нагнетание, после чего проводится прогнозный расчет на модели с упрощенной физикой. Эффект от перевода оценивается по изменению суммарной добычи нефти по сравнению с базовым расчетом. Под базовым расчетом понимается расчет без перевода каких-либо скважин в нагнетание. После завершения каждого расчета, тестируемая скважина переводится в исходное состояние </p>'+
'<h3>Просмотр результатов </h3>'+
'<p>По окончании расчета автоматически откроется страница с результатами перевода в нагнетание скважин кандидатов. &gt;Результаты расчета представлены в таблице КАНДИДАТЫ ДЛЯ ПЕРЕВОДА.<br>'+
'В крайне правом столбце таблицы приводится изменение добычи нефти после перевода соответствующей скважины. Чтобы сделать перевод скважины , нужно выделить кандидата в таблице и нажать кнопку</p>',

IDS_TOUR_SIDETRACK_HEADER: 'Построение бокового ствола',
IDS_TOUR_SIDETRACK_SUMMARY:
'<p>Зарезка боковых стволов (ЗБС) является одним из наиболее эффективных способов увеличения добычи нефти, а определение оптимального их расположения является распространенной задачей при разработке месторождений. Данный модуль предоставляет функциональные возможности для поиска целевых точек для бурения боковых стволов и выбора скважин-кандидатов для их зарезки. Процесс поиска скважин для ЗБС и оптимизации траектории ЗБС состоит из следующих этапов.</p>'+
'<ul>'+
'<li><b>Поиск целевых</b>, т. е. потенциально выгодных точек для забуривания бокового ствола. Критерием для их поиска служит наилучшая потенциальная продуктивность. Поиск базируется на моделировании с упрощенной физикой.</li>'+
'<li><b>Выбор скважин-кандидатов для ЗБС</b>. Каждая из добывающих скважин оценивается на предмет возможности зарезки бокового ствола и прокладывания его до целевой точки. По выбору пользователя применяются фильтры на продуктивность, обводненность, диаметр скважины, а также расстояние от нее до целевой точки.</li>'+
'<li><b>Построение бокового ствола</b>. Решается задача построения оптимальной кривой, соединяющей точку врезки и целевую точку.</li>'+
'<li><b>Оценка рисков</b>. Варьируя азимутом и углом отклонения по вертикали, программа строит серию (веер) кривых. Затем для каждой из них производится расчет дебита. По результатам расчета строится диаграмма.</li>'+
'</ul>',
IDS_TOUR_WFO_SUMMARY: 'Подбор оптимальных режимов работы нагнетательных скважин позволяет поддерживать пластовое давление и рационально вырабатывать запасы. Настоящий модуль позволяет определить значение приемистостей (или забойных давлений) нагнетательных скважин, которые позволяют получить максимальный прирост добычи нефти. Оптимизация происходит на основе многовариантных расчетов на модели с упрощенной физикой.',
IDS_TOUR_WFO_TABLE:
'<p>Для нахождения оптимальных режимов работы необходимо выполнить следующие действия:</p>'+
'<ul>'+
'<li>Выбрать в таблице нагнетательные скважины, режимы которых будут варьироваться в процессе '+
'оптимизации, установив флаг в крайней левой колонке. Также в таблице приведены значения базовой '+
'приемистости (или забойного давления), взятые из модели на дату мероприятия, и границ интервала, '+
'в пределах которого они будет варьироваться. Невыбранные скважины также будут учитываться в '+
'расчетах, но их режимы не будет варьироваться и останутся равными базовым значениям. </li>'+
//'<li>'+
'<ul>',
IDS_TOUR_WFO_SETTINGS:
'<p>Настройки расчета</p>'+
'<ul>'+
'<li>Оптимизируемые параметры. Работа нагнетательных скважин может задаваться с помощью задания их приемистостей или забойного давления.</li>'+
'<li>Фиксированная закачка. Нужно активизировать эту настройку если необходимо держать общий темп закачки всех нагнетательных скважин.</li>'+
'<li>В результате расчетов оптимизируется целевая функция H, которая имеет размерность тыс. рублей. Для ее задания необходимо ввести весовые коэффициенты, которые означают стоимость добычи тонны нефти и воды (коэффициенты A, B), а также стоимость закачки тонны воды (коэффициент С).</li>'+
'</ul>',
IDS_TOUR_WFO_RESULTS:
'<p>Просмотр результатов</p>'+
'<p>После окончания расчетов автоматически откроется страница с результатами вычислений. Результаты представляются 4-мя различными представлениями.</p>',
IDS_TOUR_CANDIDATE_WELLS_HEADER: 'Подбор скважин',
IDS_TOUR_CANDIDATE_WELLS_SUMMARY: 'На этом этапе производится подбор скважин, из которых можно провести боковой ствол в выбранную точку T1. Для этого из каждой добывающей скважины проводятся боковые стволы в выбранную точку T1. Все боковые стволы должны удовлетворять условиям на максимальную кривизну (685 м) и предельный угол отхода от материнского ствола (30 градусов). Если из скважины удается провести траекторию в точку T1, то ее индикатор будет иметь зеленый цвет. В противном случае скважина будет иметь красный идентификатор.',
IDS_TOUR_CANDIDATE_WELLS_FILTER_TITLE: 'Фильтр',
IDS_TOUR_CANDIDATE_WELLS_FILTER_TEXT: 'Список скважин кандидатов может быть ограничен с помощью специальных фильтров, использующих промысловую информацию о добывающих скважинах. Работа фильтров по дебиту нефти, обводненности и диаметру колонны требует подключения к источнику данных с промысловой информацией.',
IDS_TOUR_CANDIDATE_WELLS_TABLE_TITLE: 'Таблица добывающих скважин',
IDS_TOUR_CANDIDATE_WELLS_TABLE_TEXT: 'Если из добывающей скважины существует возможность провести боковой ствол, удовлетворяющий выбранным фильтрам и технологическим ограничениям, то такие скважины будут маркироваться в таблице ДОБЫВАЮЩИЕ СКВАЖИНЫ зеленым кружком. Скважины, из которых нельзя провести боковой ствол, маркируются красным кружком. Если подвести указатель курсор мышки на красный кружок, то появится всплывающая подсказка, объясняющая причину невозможности проведения бокового ствола.',
IDS_TOUR_TRAJ_EDIT_SIDETRACK_BY_SWEET_SPOT_HEADER: 'Редактор траекторий',
IDS_TOUR_TRAJ_EDIT_SIDETRACK_BY_SWEET_SPOT_SUMMARY:
'После окончания расчета различных траекторий автоматически выбирается геометрия бокового ствола, которая обеспечивает максимальный стартовый дебит. Характеристики выбранной траектории (длина ствола в пласте, его дебит и кривизна) представлены в разделе ПАРАМЕТРЫ ТРАЕКТОРИИ.'+
'<p>Если по каким либо причинам выбор траектории бокового ствола не является оптимальным, его можно изменить. Это можно сделать двумя способами</p>',
IDS_TOUR_TRAJ_EDIT_SIDETRACK_BY_SWEET_SPOT_1:
'<b>Ручное изменение текущей траектории.</b> Выбранная траектория может быть изменена с помощью мышки. Для этого необходимо навести указатель мышки на специальные точки маркирующие траекторию скважины и переместить точку, удерживая левую кнопку мышки.',
IDS_TOUR_TRAJ_EDIT_SIDETRACK_BY_SWEET_SPOT_2:
'<b>Выбрать другую рассчитанную траекторию.</b> В разделе РАСПРЕДЕЛЕНИЕ ПРОДУКТИВНОСТИ представлена гистограмма показывающая распределение дебита для возможных траекторий боковых стволов. Если необходимо выбрать другую траекторию, нужно навести указатель мышки на левый верхний угол нужного столбца гистограммы. При этом появится индикатор (точка), по которому нужно щелкнуть левой кнопкой мышки. В результате в поле графика отобразится зависимость дебита бокового ствола от его азимута. Каждая точка этой зависимости соответствует определенной траектории. Если выбрать какую-либо точку с помощью левой кнопки мышки, то соответствующая траектория отобразится на карте и на разрезе. Нажмите кнопку ПРИМЕНИТЬ, чтобы зафиксировать выбранную траекторию.',

IDS_TOUR_LOW_PRESSURE_ZONE_HEADER: 'Поиск зон пониженного давления',
IDS_TOUR_LOW_PRESSURE_ZONE_SUMMARY:
    'В этом модуле выбираются добывающие скважины, которые находятся в зоне пониженного давления '+
    'с невыработанными остаточными запасами. '+
    '<p>'+
    '<p>Повышение пластового давления на таких скважинах может приводить к увеличению добычи нефти. '+
    '<p>'+
    'В дальнейшем эти скважины будут использоваться при оптимизации режимов работы нагнетательных '+
    'скважин, а также при оптимизации переводов скважин в нагнетание. ',

IDS_TOUR_LOW_PRESSURE_ZONE_FILTER_TITLE: 'Область поиска',
IDS_TOUR_LOW_PRESSURE_ZONE_FILTER_TEXT:
    '<p>Фильтр <b>«Плотность мобильных запасов»</b>. Ячейки, которые не ' +
    'удовлетворяют условию фильтра, закрашиваются серым цветом. ' +
    '<p>Фильтр <b>«Среднее пластовое давление»</b>. Ячейки, которые не ' +
    'удовлетворяют условию фильтра, изображаются полупрозрачными.' +
    '<p>Ниже выводится информация о количестве <b>Подвижных запасов</b>, '+
    '<b>Площади</b> и усредненном <b>Пластовом давлении</b>. '+
    'Эти величины рассчитываюстя в области, в которой выполнены условия, задданные фильтрами. ',
IDS_TOUR_LOW_PRESSURE_ZONE_TABLE_TITLE: 'Добывающие скважины',
IDS_TOUR_LOW_PRESSURE_ZONE_TABLE_TEXT:
    'В результате применения фильтров в таблице автоматически выделятся скважины, '+
    'находящиеся в выбранной зоне. Список выбранных скважин может быть изменен вручную. '+
    '<p>'+
    'Необходимо помнить, что повторное применение фильтров приведет к потере результатов ручного редактирования.',
IDS_TOUR_PERF_EDIT_SUMMARY_TITLE: 'Редактор перфораций',
IDS_TOUR_PERF_EDIT_SUMMARY_TEXT:
    'Перфорации проектируемых скважин можно задавать как с помощью специальных фильтров, так и вручную, с помощью мышки. '+
    '<p>'+
    '<li>Фильтр <b>по нефтенасыщенности</b> дает возможность проперфорировать ствол скважины в пределах тех ячеек, в которых нефтенасышенность '+
    'лежит в пределах выбранного диапазона значений. Этот фильтр работает только при наличии трехмерной сетки.</li>'+
    '<p>'+
    '<li>Фильтр <b>по расстоянию до ВНК</b>. Если имеется трехмерная сетка, то этот фильтр перфорирует ячейки, через которые проходит скважина, расстояние от центра которых '+
    'до ВНК будет не меньше выставленного значения.</li>'+
    '<p>'+
    '<li>Фильтр <b>по абсолютной глубине</b> позволяет проперфорировать скважину в заданном диапазоне глубин.</li>',
IDS_TOUR_PROJECT_MANAGER_TITLE: 'Менеджер проектов',
IDS_TOUR_PROJECT_MANAGER_SUMMARY_1:
    'В этом модуле создается проект, который в дальнейшем будет использоваться во всех прикладных модуляx программы. '+
    '<p>'+
    '<p>Проект содержит ссылки на источники данных: гидродинамическая модель, '+
    'геологическая модель и источник промысловых данных. ' +
    '<p>'+
    'Для работы программы достаточно существования хотя бы одной из этих ссылок. Отсутствие указателей на какой-либо '+
    'источник данных может приводить к невозможности использования всего доступного функционала программы.',
IDS_TOUR_PROJECT_MANAGER_SUMMARY_2: 'В разделе <b>гидродинамическая модель</b> устанавливается путь на входной файл (data file) уже рассчитанной гидродинамической модели. Модель может быть в форматах ECLIPSE, TEMPEST, NEXUS, '+
    'ТехСхема.'+
    '<p>'+
    '<p>В разделе <b>геологическая модель</b> устанавливается путь на папку, в которой находится геологическая модель. Модель может иметь формат RMS.'+
    '<p>В разделе <b>промысловая информация</b> необходимо выбрать источник с промысловой информацией. По умолчанию используется RDS'+
    '<p>Предполагается, что все эти источники информации относятся к одному месторождению.',
IDS_TOUR_PROJECT_MANAGER_MAPS_TITLE: 'Свойства пласта',
IDS_TOUR_PROJECT_MANAGER_MAPS_TEXT: 'Для работы некоторых прикладных модулей программы требуются данные о пространственном распределении свойств пласта таких как:'+
    '<p>'+
    '<li>Проницаемость</li>'+
    '<li>Пластовое давление</li>'+
    '<p>'+
    '<p>Эти параметры будут использоваться при оценке продуктивности новых скважин. Свойства пласта задаются в виде карт или константных значений. Если в имеющихся источниках данных не находится карта текущего '+
    'пластового давления, то ее можно рассчитать по информации, имеющейся в источнике промысловой информации.',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_SUMMARY_TITLE: 'Расчет пластового давления',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_SUMMARY_TEXT: 'Для построения карты пластовых давлений на выбранную дату используется информация о текущих дебитах скважин и имеющихся замерах пластового давления. Построение ведется на основании ' +
    'гибридного подхода.' +
    '<p>' +
    '<p>Для построения карты пластовых давлений нужно: ' +
    '<p>' +
    '<ul>' +
    '<li>Выбрать дату, на которую будет строиться карта пластового давления. При этом из базы данных будут загружаться режимы работы скважин на выбранную дату. </li>' +
    '<li>В разделе Прочее необходимо задать значения пластового давления на границах моделируемой области. Чаше всего его роль играет начальное пластовое давление. </li>' +
    '</ul>',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_TABLE_TITLE: 'Расчет пластового давления',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_TABLE_TEXT:
    'Таблица Режим работы скважин содержит информацию о режимах работы скважин ' +
    'на выбранную дату. ' +
    '<p>' +
    '<ul>' +
    '<li>Голубым цветом помечаются имена и приемистости нагнетательных скважин. ' +
    '<li>Поскольку оценок пластовых давлений сравнительно немного, то подгружаются те оценки, ' +
    'которые проводились менее чем за три месяца до выбранной даты. ' +
    '</ul>',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_PERM_TITLE: 'Расчет пластового давления',
IDS_TOUR_PROJECT_MANAGER_PRESSURE_MAP_PERM_TEXT:
    'При расчете пластового давления используются данные о проницаемости ' +
    'пласта, которые задавались на предыдущем шаге, в окне <b>Менеджер проектов. ' +
    'Редактировать проект.</b> ',
    
IDS_TOUR_MODEL_DATA_FILTER_HEADER: 'Фильтр по модельным данным',
IDS_TOUR_MODEL_DATA_FILTER_SUMMARY: 'В этом модуле рассчитываются коэффициенты влияния нагнетательных скважин на добычу нефти (третья колонка в таблице НАГНЕТАТЕЛЬНЫЕ СКВАЖИНЫ) и создается карта трассеров по выбранным нагнетательным скважинам.' +
    'Чтобы рассчитать карту трассеров и коэффициенты влияния необходимо выполнить следующие действия:',
IDS_TOUR_MODEL_DATA_FILTER_TABLE_TITLE: 'Таблица нагнетательных скважин',
  IDS_TOUR_MODEL_DATA_FILTER_TABLE_TEXT:
    '<p>Отметьте представляющие интерес скважины в крайней ' +
    'левой колонке таблицы <b>Нагнетательные скважны</b>. В ней приведены значения ' +
    'базовой приемистости, взятые из модели на дату мероприятия. </p>' +
    '<p>За основу для коэффициентов влияния берется информация о том, когда нагнетательная ' +
    'скважина работает с базовой приемистостью и когда — с дополнительной. </p>' +
    '<p>Также в крайней правой колонке по контекстному меню можно получить дополнительную ' +
    'информацию. </p>',
IDS_TOUR_MODEL_DATA_FILTER_CALC_SETTINGS_TITLE: 'Задать настройки расчета:',
IDS_TOUR_MODEL_DATA_FILTER_CALC_SETTINGS_TEXT:
    '<p>Время расчета' +
    '<p>Тип залежи',
IDS_TOUR_MODEL_DATA_FILTER_CALC_ACTIONS_TITLE: 'Результаты расчета',
IDS_TOUR_MODEL_DATA_FILTER_CALC_ACTIONS_TEXT: 'Для запуска на расчет нажмите кнопку «Рассчитать». После окончания расчетов автоматически откроется раcсчитанная динамическая карта трассеров. Также ее можно открыть нажатием кнопки «Результаты».',
IDS_TOUR_MODEL_DATA_FILTER_CALC_RESULT_TIME_TITLE: 'Временной шаг',
IDS_TOUR_MODEL_DATA_FILTER_CALC_RESULT_TIME_TEXT: 'Двигаясь по временным шагам, можно наблюдать, как распространяется вода от нагнетательных скважин',
IDS_TOUR_MODEL_DATA_FILTER_CALC_RESULT_TABLE_TITLE: 'Таблица нагнетательных скважин',
IDS_TOUR_MODEL_DATA_FILTER_CALC_RESULT_TABLE_TEXT: 'В таблице РЕЗУЛЬТАТЫ РАСЧЕТОВ, в третьей колонке, отображаются коэффициенты влияния. В крайней правой колонке по контекстному меню доступна подробная информация по расчету',

IDS_TOUR_SELECT_WELL_IN_TREE:
    '<p>В дереве можно выбрать {0} для дальнейшей работы. </p>'+
    '<p>При этом необходимо иметь в виду, что редактирование {1}, {2}, из '+
    'модели, запрещено. </p>',
IDS_TOUR_TRAJ_EDIT_SUMMARY_TITLE_1:'Назначение модуля',
IDS_TOUR_TRAJ_EDIT_SUMMARY_TEXT_1:
    '<p>Это модуль позволяет визуализировать траектории как новых, так и уже существующих '+
    'скважин. При этом траектории новых скважин доступны для редактирования. <p>'+
    '<p>Траектория выбранной в дереве скважины выделяется на карте и на разрезе, '+
    'а также отображаться в табличном виде в панели справа. </p>',
IDS_TOUR_EDIT_NEW_WELL_TITLE:'Создание новой скважины',
IDS_TOUR_EDIT_NEW_WELL_TEXT:
    '<ul>'+
  '<p><li>Для создания {0} {1} нажмите кнопку <b>+</b>, находящуюся в правом нижнем '+
    'углу центральной панели. После этого новая скважина появится в дереве данных, '+
    'а программа автоматически перейдет в режим создания траектории. </li></p>'+
  '<p><li>Траектория скважины задается точками. Двойной щелчок мышки на карте добавляет новую точку в конец траектории. </li></p>'+
    '</ul>',
IDS_TOUR_TRAJ_EDIT_SUMMARY_TITLE_2: 'Редактирование траектории',
IDS_TOUR_TRAJ_EDIT_SUMMARY_TEXT_2:
    '<p>Доступно два способа редактирования траектории: </p>'+
    '<ul>'+
  '<li>Интерактивно, c помощью мышки, на карте либо на разрезе. </li>'+
    '<li>Внося изменения в таблицу <b>Траектория</b>. </li>'+
    '</ul>',
IDS_TOUR_TRAJ_MASTER_TITLE:'Создание по шаблону',
IDS_TOUR_TRAJ_MASTER_TEXT:
    'Задайте <b>длину</b> ствола, его <b>азимут</b> и <b>отклонение от '+
    'вертикали</b> и нажмите кнопку «<b>Создать</b>». В результате скважина получит '+
    'траекторию, состоящую из двух точек и соответствующую заданным параметрам. ',
IDS_TOUR_TRAJ_INTERACTIVE_TITLE: 'Интерактивное редактирование траектории',
IDS_TOUR_TRAJ_INTERACTIVE_TEXT:
    '<li>Чтобы добавить точку в конец траектории, используйте двойной щелчок. '+
    'щелчок. '+
    '<p><li>Можно также передвигать определенные точки траектории в горизонтальном '+
    '– на карте либо в вертикальном – на разрезе направлениях. Для этого следует '+
    'навести курсор мышки на траекторию в нужном месте и, удерживая нажатой левую '+
    'кнопку, переместить точку.</p>' +
    '<p><li>Удалить точку можно с помощью контекстного меню, предварительно наведя на нее '+
    'курсор мышки.</p>'+
    '<p>Изменения, произведенные таким образом, автоматически отобразятся в таблице. ',
IDS_TOUR_TRAJ_TABLE_TITLE: 'Траектория',
IDS_TOUR_TRAJ_TABLE_TEXT:
    'Выделите щелчком мышки нужную ячейку: «X», «T» или «TVD» и отредактируйте '+
    'ее содержимое. По правой кнопке мышки, а также по значку <b>⋮</b> доступны команды: '+
    '<p><li>«Добавить». Добавляет пустую строку в конец таблицы для последующего ее '+
    'заполнения. Незаполненная строка будет проигнорирована.</p>'+
    '<p><li>«Вставить». Добавляет новую точку в середину отрезка, концам которого '+
    'соответствует текущая и следующая строки таблицы. Если текущая строка является '+
    'последней, данная команда будет эквивалентна команде «Добавить».</p>'+
    '<p><li>«Удалить». Удаляет текущую точку.</p>'+
    '<p>Изменения, внесенные в таблицу, автоматически отобразятся на карте и разрезе. ',
IDS_TOUR_PERF_SUMMARY_TITLE: 'Редактирование интервалов перфораций',
IDS_TOUR_PERF_SUMMARY_TEXT:
    'Перфорации проектируемых скважин можно задавать и изменять тремя способами: ' +
    '<p>' +
    '<li>Вручную, с помощью мышки на карте либо на разрезе. ' +
    '<li>Внося изменения в таблицу «<b>Интервалы перфораций</b>». ' +
    '<li>С помощью фильтров. ',
IDS_TOUR_PERF_TABLE_TITLE: 'Интервалы перфораций',
IDS_TOUR_PERF_TABLE_TEXT:
    'Таблица «<b>Интервалы перфораций</b>» содержит информацию о ' +
    'событиях на скважине, привязанных к определенной дате. События ' +
    'могут быть двух типов: перфорация или изоляция. Каждая строка ' +
    'таблицы соответствует определенному интервалу перфорации либо изоляции. ' +
    '<p>' +
    '<p>В строку можно вносить изменения, выделяя щелчком мышки нужную ' +
    'ячейку, с последующим ее редактированием. Также можно удалить ' +
    'ее целиком, используя контекстное меню, открывающееся по правой '+
    'кнопке мышки или по значку <b>⋮</b>. ' +
    '<p>' +
    '<p>Изменения, внесенные в таблицу, автоматически отобразятся на ' +
    'карте и разрезе. При этом фильтры в панели «<b>Настройки перфораций</b>» ' +
    'будут сброшены. ',
IDS_TOUR_PERF_INTERACTIVE_TITLE: 'Интерактивное редактирование интервалов перфораций',
IDS_TOUR_PERF_INTERACTIVE_TEXT:
    '<p>' +
    '<li>Чтобы <b>создать новый</b> интервал, следует навести курсор ' +
    'мышки на траекторию выделенной скважины в требуемой точке и, ' +
    'удерживая нажатой левую кнопку, «протянуть» интервал вдоль ствола ' +
    'скважины. ' +
    '<p>' +
    '<li>Также можно изменить либо удалить целиком существующий интервал. ' +
    'Для этого нужно навести курсор мышки на один из концов. Затем, с ' +
    'целью изменить его положение, удерживая нажатой левую кнопку мышки, ' +
    'переместить курсор вдоль ствола скважины. ' +
    '<p>' +
    '<li>Удалить интервал целиком можно с помощью контекстного меню, ' +
    'предварительно наведя курсор мышки на данный интервал. ' +
    '<p>' +
    'Изменения, произведенные таким образом, автоматически отобразятся в '+
    'таблице интервалов. А фильтры в панели «Настройки перфораций» будут сброшены. ',
IDS_TOUR_PERF_SETTINGS_TITLE: 'Настройки перфораций',
IDS_TOUR_PERF_SETTINGS_TEXT:
    'Перфорации проектируемых скважин можно также задавать с помощью ' +
    'специальных фильтров. Интервалы перфораций будут определятся ' +
    'наложением, используемых фильтров. Изменение настроек этих фильтров ' +
    'приведет к удалению старых интервалов перфораций. ',
IDS_TOUR_PERF_FILTERS:
    '<p>Фильтр <b>«Нефтенасыщенность».</b> Перфорированы будут ячейки, удовлетворяющие ' +
    'условию фильтра и находящие в области поиска' +
    '<p>Фильтр <b>«Расстояние до ВНК».</b> Перфорированы будут ячейки, центр которых расположен ' +
    'от ВНК на расстоянии, не большим заданного ' +
    '<p>Фильтр <b>"Глубина".</b> Ствол скважины будет перфорирован в указанном диапазоне глубин. ',
    IDS_TOUR_WELL_PRODUCTIVE_TITLE: 'Прогноз добычи ',
    IDS_TOUR_WELL_PRODUCTIVE_TEXT:
        'При поиске оптимальных мест для бурения новых {0} использовались значения '+
        'их стартового дебита. На данной стадии можно сделать прогноз '+
        'среднесрочного дебита {1}.'+
        '<p>'+
        'Для этого необходимо задать:'+ 
        '<ul>'+
        '<li>длительность расчета;</li> '+
        '<li>забойное давление.</li> '+
        '</ul>'+
        '<p>'+
        'По умолчанию все настройки будут идентичны тем, с которыми проводился расчет '+
        'стартового дебита, но они могут быть изменены.',

IDS_TOUR_PROJECT_PAGE_WELL_PATTERN_TITLE_1: 'Расстановка по шаблону',
IDS_TOUR_PROJECT_PAGE_WELL_PATTERN_TEXT_1: 'На этой стадии можно задать шаблон для расстановки скважин.',
IDS_TOUR_PROJECT_PAGE_WELL_PATTERN_TITLE_2: 'Настройки шаблона',
IDS_TOUR_PROJECT_PAGE_WELL_PATTERN_TEXT_2: 'Здесь можно настроить параметры шаблона для расстановки скважин.',
};

export default { translation };
